const ZPARCoordinates = [
  // ID Palermo: V1-C-1003694
  [
    [-58.42906092921845, -34.55090033208461],
    [-58.4267588356517, -34.552019672369966],
    [-58.426246118663414, -34.55190137644735],
    [-58.42542843167672, -34.55219791710016],
    [-58.42453828721216, -34.552512285013904],
    [-58.42423352855445, -34.55264409055229],
    [-58.422776178977415, -34.55304770538726],
    [-58.42272815428083, -34.552917851377686],
    [-58.42221423759696, -34.55304525743264],
    [-58.422257051621614, -34.553169248761776],
    [-58.42127299275438, -34.553414877894284],
    [-58.420390147187504, -34.553636108419596],
    [-58.42017898637107, -34.553688690880335],
    [-58.420008636789134, -34.55373182056701],
    [-58.41987163856521, -34.553764322965094],
    [-58.41977275630762, -34.55378800211457],
    [-58.41971702172316, -34.553801867861864],
    [-58.41966919757539, -34.55381312197795],
    [-58.419599440761544, -34.55383031971343],
    [-58.41948024102027, -34.55385958185417],
    [-58.41937964915144, -34.55388434288807],
    [-58.41928211407827, -34.553907661409426],
    [-58.41917289141577, -34.55393981217253],
    [-58.41907256934354, -34.55396285999797],
    [-58.418935568421716, -34.55399896867743],
    [-58.418779961426026, -34.55403633281048],
    [-58.418633253222026, -34.55407324998043],
    [-58.418496253199464, -34.55410899803178],
    [-58.41839062692583, -34.55413339663892],
    [-58.41824562743369, -34.554169772417026],
    [-58.41811698660962, -34.55420155625677],
    [-58.418007764846436, -34.55422892892187],
    [-58.41738371178883, -34.55438397653927],
    [-58.41749189573437, -34.55403953439696],
    [-58.41709214618555, -34.55386821264784],
    [-58.41480786369192, -34.55418230177179],
    [-58.41275489672108, -34.555188947112185],
    [-58.41258068814818, -34.55532444256892],
    [-58.409804820935676, -34.5565484063838],
    [-58.409480026282154, -34.55660785876563],
    [-58.40934842309122, -34.55676630851826],
    [-58.40933996137011, -34.55692616840793],
    [-58.40866885398441, -34.55829401026034],
    [-58.408556550244555, -34.558451236035694],
    [-58.40795501621096, -34.55929338368264],
    [-58.40744105186303, -34.55963602628157],
    [-58.40698419536426, -34.5603213114793],
    [-58.40624180411595, -34.56089238187786],
    [-58.40607048236683, -34.56140634532653],
    [-58.40532974766967, -34.56209034629239],
    [-58.4047284663456, -34.562662700922886],
    [-58.4047284663456, -34.56300534262243],
    [-58.404415075095585, -34.56282331894096],
    [-58.40394165848073, -34.56346307146356],
    [-58.403493043369224, -34.563229254026794],
    [-58.39881084274617, -34.56078890588327],
    [-58.398721277464915, -34.56089126581924],
    [-58.403345750605865, -34.56332058737519],
    [-58.40392886292665, -34.56359102160832],
    [-58.403545011592996, -34.56377015217072],
    [-58.40285407865275, -34.56396207828726],
    [-58.402115492435996, -34.56382358628946],
    [-58.40143382790882, -34.563360710628274],
    [-58.40108836233799, -34.563335120419424],
    [-58.400883641566736, -34.56346307146356],
    [-58.400886122796294, -34.56368905490592],
    [-58.40113833586548, -34.564035173384525],
    [-58.40071003284169, -34.56432070903344],
    [-58.39976210153969, -34.563546107666696],
    [-58.39927709895892, -34.56359238498055],
    [-58.397312163025845, -34.56490129785658],
    [-58.39693144852748, -34.56490129785658],
    [-58.396693502303265, -34.565662725054665],
    [-58.397121805327004, -34.56599584922901],
    [-58.39760232838472, -34.56620658466613],
    [-58.397693329883225, -34.56660763823186],
    [-58.39796744324286, -34.56694266627096],
    [-58.39826033714479, -34.56695672357387],
    [-58.39827031242493, -34.56696123817056],
    [-58.39828307200611, -34.56696836799574],
    [-58.39831191506278, -34.56698560620072],
    [-58.39832494444062, -34.566993818809635],
    [-58.39833851071364, -34.567002931639934],
    [-58.398352887275905, -34.56701339974853],
    [-58.39837157428866, -34.56702882761823],
    [-58.39838585732144, -34.56704263221167],
    [-58.39846589158759, -34.56712436619648],
    [-58.39855913509598, -34.56721521481029],
    [-58.39858572265291, -34.56724282039977],
    [-58.39859668089207, -34.56725499901893],
    [-58.39862434403818, -34.56728909681431],
    [-58.39864472987034, -34.567315437057744],
    [-58.3986674530405, -34.56734349140896],
    [-58.398738318718415, -34.56742458867376],
    [-58.39877119163714, -34.567463108435675],
    [-58.398796789040546, -34.567494680934715],
    [-58.39881043984985, -34.567511278822394],
    [-58.39881987104019, -34.56752228382629],
    [-58.39883541132514, -34.56753951483671],
    [-58.398872420225985, -34.56757731424159],
    [-58.39890790207795, -34.56761249841804],
    [-58.39897841702032, -34.56768349809494],
    [-58.39902773404265, -34.56773338708609],
    [-58.399064472247574, -34.56777199767953],
    [-58.39910884389798, -34.56782017076421],
    [-58.39916812720725, -34.5678861162512],
    [-58.399205134309454, -34.56792680068128],
    [-58.39926199304648, -34.56798670182479],
    [-58.39931669970588, -34.568041824870306],
    [-58.39940698084746, -34.56812915533618],
    [-58.39950040511957, -34.56822207778663],
    [-58.399548734686334, -34.568267819104506],
    [-58.39957226994426, -34.56829145508652],
    [-58.39959544367474, -34.5683182467896],
    [-58.399624454904654, -34.5683527070118],
    [-58.39964790023038, -34.56837796627008],
    [-58.3996710757595, -34.568401240724654],
    [-58.399691109057414, -34.56842054826967],
    [-58.39971186001429, -34.56843967505091],
    [-58.39972101871001, -34.56845428723551],
    [-58.39974598209136, -34.56849289063433],
    [-58.39976457107804, -34.56852022193067],
    [-58.39979842695578, -34.56856640481567],
    [-58.399828874403, -34.56860564493451],
    [-58.39987530819889, -34.56866292635294],
    [-58.399934319013596, -34.56873184499858],
    [-58.400002314954804, -34.568808703758634],
    [-58.400031958408135, -34.56884100021193],
    [-58.40008423779727, -34.56889521764015],
    [-58.40010094810026, -34.568910917105086],
    [-58.400126552698225, -34.56893221035318],
    [-58.400155035126716, -34.5689542257569],
    [-58.4001589876471, -34.56895702264842],
    [-58.40016518757329, -34.56896054259494],
    [-58.40017534271783, -34.568965327887554],
    [-58.40018316142374, -34.56896930019303],
    [-58.40018927231705, -34.568973269800495],
    [-58.40019340380252, -34.56897669891549],
    [-58.400197177357825, -34.56898057769149],
    [-58.40020103904669, -34.56898590077867],
    [-58.4002042712101, -34.56899203325571],
    [-58.400205795560964, -34.56899591113233],
    [-58.400222227074096, -34.56902351132595],
    [-58.400212872326165, -34.569030899256575],
    [-58.400189033996696, -34.569049730160884],
    [-58.40016510663435, -34.569068471132994],
    [-58.40014127010352, -34.5690872121051],
    [-58.40011734274111, -34.56910586314501],
    [-58.40009332634588, -34.5691244233534],
    [-58.40006930905133, -34.56914289362959],
    [-58.3995404654201, -34.57036854277396],
    [-58.399721303795104, -34.57087267123677],
    [-58.402633765435894, -34.57412777367779],
    [-58.40128223099015, -34.575679182448255],
    [-58.39857916299792, -34.577163965844306],
    [-58.39659930101686, -34.57853401463302],
    [-58.39793194969968, -34.58041906918464],
    [-58.399207341245756, -34.58245588702954],
    [-58.399416733095734, -34.582931778578654],
    [-58.40008298234375, -34.58384549157614],
    [-58.40056839231744, -34.58447763583416],
    [-58.401215605615675, -34.58386849443542],
    [-58.40209124671361, -34.583430672987106],
    [-58.406145849151585, -34.583430672987106],
    [-58.4080303820964, -34.586152776029735],
    [-58.410181414740464, -34.58914137877156],
    [-58.41301773168294, -34.59247262501157],
    [-58.414407338028184, -34.59405258725707],
    [-58.41598730027363, -34.59784068909647],
    [-58.42061297221085, -34.5977645461968],
    [-58.423436435143344, -34.597676661748494],
    [-58.427362546044606, -34.59593965629006],
    [-58.43233561889366, -34.592846356274265],
    [-58.4411872141186, -34.5868501148409],
    [-58.44478019994625, -34.584565832347266],
    [-58.44439948724647, -34.58320953868923],
    [-58.444479504425544, -34.583175707992496],
    [-58.44343176276561, -34.5817610573269],
    [-58.441581493990725, -34.58004784523183],
    [-58.4399291956758, -34.57854021815649],
    [-58.44085813779276, -34.577824475619025],
    [-58.44183276457039, -34.576766092281275],
    [-58.44397999128353, -34.57537268000516],
    [-58.44073631023247, -34.57212423974181],
    [-58.4448480178217, -34.5699732070978],
    [-58.44897909500918, -34.56783427393253],
    [-58.44778728735338, -34.56659620874797],
    [-58.442685722967724, -34.563588570056424],
    [-58.44244206604844, -34.563588570056424],
    [-58.441513123931486, -34.562598714159265],
    [-58.44137606725167, -34.56206571476088],
    [-58.43879292475361, -34.56239312913954],
    [-58.435247528350715, -34.56246451192766],
    [-58.43489060811504, -34.562083799227935],
    [-58.43481922532692, -34.561798262679645],
    [-58.43527132171408, -34.561798262679645],
    [-58.436936945283776, -34.56186964726635],
    [-58.43793631870608, -34.561774469316276],
    [-58.439268817202105, -34.56136995965585],
    [-58.44045854742399, -34.560489560244946],
    [-58.44114859093469, -34.55949018592332],
    [-58.4413627419969, -34.5586573750378],
    [-58.44112479577268, -34.55799112578978],
    [-58.44033957431185, -34.557277287117074],
    [-58.437650783057165, -34.55620653000733],
    [-58.43588998243672, -34.55487403241062],
    [-58.43408159239152, -34.55389845325095],
    [-58.43472404557821, -34.55347015022721],
    [-58.434533688778686, -34.55308943572885],
    [-58.430916908688346, -34.55111448314682],
    [-58.42906092921845, -34.55090033208461]
  ],
  // ID Puerto Madero: V1-C-1003655
  [
    [-58.36343223470982, -34.625102152142574],
    [-58.365854983120926, -34.62369505128555],
    [-58.366796292714696, -34.61562575382544],
    [-58.367786719681305, -34.60702314580152],
    [-58.36840538040394, -34.60116967174292],
    [-58.36948194263749, -34.59821550314291],
    [-58.36788294624091, -34.59838682399271],
    [-58.36612785541615, -34.59829964101556],
    [-58.36302123104491, -34.59819304077615],
    [-58.36340194464401, -34.5971422710989],
    [-58.35867607204307, -34.59496782370604],
    [-58.3586672955592, -34.59501073395819],
    [-58.358497243652835, -34.59493908317211],
    [-58.35429034012708, -34.59468858331144],
    [-58.35426129382358, -34.59468801673853],
    [-58.351140110327776, -34.59516682838637],
    [-58.35113832697215, -34.59535653227812],
    [-58.351850792380105, -34.59524400640572],
    [-58.35427950869234, -34.59485718191337],
    [-58.35710221169768, -34.595077785611295],
    [-58.357320897141676, -34.59509186539725],
    [-58.35729390219177, -34.595105455951966],
    [-58.3572278541821, -34.595138128321935],
    [-58.357087022148335, -34.59514260065043],
    [-58.356974302022365, -34.59517514082006],
    [-58.35687278834848, -34.59523564181137],
    [-58.35680975216826, -34.595232880892695],
    [-58.35647217005459, -34.59537089535047],
    [-58.35627596856108, -34.59542554265465],
    [-58.35597014870336, -34.5954777482994],
    [-58.355670135768094, -34.59548938462734],
    [-58.35552307413053, -34.5955131483131],
    [-58.35519116044367, -34.595646389169474],
    [-58.35515939818765, -34.59572985434926],
    [-58.35508704413172, -34.595770184446394],
    [-58.354977335835315, -34.59597539175087],
    [-58.354769590644025, -34.59605392235062],
    [-58.35458208469544, -34.596058534973395],
    [-58.35452141822884, -34.596101399360066],
    [-58.35430214013161, -34.59619659979319],
    [-58.35412225773598, -34.59628489343305],
    [-58.3539464249875, -34.59637120496711],
    [-58.353540149957894, -34.59662998038925],
    [-58.35343620091987, -34.596691921195145],
    [-58.353294719575615, -34.596846788948085],
    [-58.35304635200748, -34.59703979335171],
    [-58.35280925474325, -34.59748319419401],
    [-58.3526331198226, -34.59765958092487],
    [-58.35238184834361, -34.59793832939033],
    [-58.35210482297913, -34.59803591302693],
    [-58.35195752302121, -34.59816697212801],
    [-58.351787089802315, -34.59838150360349],
    [-58.3516311329704, -34.59852923613528],
    [-58.351524253041816, -34.59862931539055],
    [-58.35132505410792, -34.59876501679207],
    [-58.35115182579608, -34.598915169399504],
    [-58.35094390703563, -34.59904851817453],
    [-58.35084870210585, -34.59909135198427],
    [-58.350663984055586, -34.59915800074111],
    [-58.35058311611789, -34.5992390773215],
    [-58.35049077642816, -34.5992913818917],
    [-58.35032032882009, -34.599510692364504],
    [-58.350207709418214, -34.59959642833246],
    [-58.35000833871379, -34.59985628743766],
    [-58.34987266878858, -34.59996111871061],
    [-58.34973109481416, -34.60010886383293],
    [-58.34955205778118, -34.60022790259558],
    [-58.349344278415685, -34.60032076928803],
    [-58.348772502049314, -34.60083546388552],
    [-58.348608008852466, -34.60090447516137],
    [-58.348492603350905, -34.60092105326396],
    [-58.348403196350375, -34.6009305321183],
    [-58.34830498138973, -34.60100194638267],
    [-58.3480740642666, -34.60110910600042],
    [-58.34801923889671, -34.601149535922275],
    [-58.34772767779003, -34.60134246927947],
    [-58.347548761266296, -34.601370874366296],
    [-58.34750832055249, -34.60141384307434],
    [-58.347404408386694, -34.60144232190561],
    [-58.34723981086853, -34.60158525025906],
    [-58.3471388188014, -34.60164718297108],
    [-58.347063666055305, -34.60175440464201],
    [-58.347020259377416, -34.60186174772144],
    [-58.346996974131, -34.601985701279034],
    [-58.34692764539449, -34.602042885570654],
    [-58.34691025070748, -34.602133485072216],
    [-58.34684372066113, -34.60224792829922],
    [-58.34680617486504, -34.602278907245704],
    [-58.34681483893365, -34.60232183458493],
    [-58.34675983279999, -34.60242673240771],
    [-58.34674503625439, -34.60272002201134],
    [-58.34665398079653, -34.60281325292925],
    [-58.34664959210494, -34.60286545317808],
    [-58.34670440308571, -34.602901302852786],
    [-58.34672146502356, -34.60304919006802],
    [-58.34665496735283, -34.60320411717623],
    [-58.34664041002685, -34.60325901269323],
    [-58.346582516170145, -34.60343540841734],
    [-58.346625563119176, -34.60358809891159],
    [-58.34656188931967, -34.603716880929255],
    [-58.34653280974135, -34.60393144388098],
    [-58.34654133531433, -34.60401016603629],
    [-58.34646605756245, -34.60420331433147],
    [-58.34647458943073, -34.60427725659008],
    [-58.34638777427631, -34.60448941925125],
    [-58.34635871088574, -34.604627702606365],
    [-58.34631525474515, -34.60476840693639],
    [-58.346237669332936, -34.60481151863661],
    [-58.34617372034086, -34.604877997421625],
    [-58.3460726437375, -34.60499709464017],
    [-58.34608975513805, -34.6051092760722],
    [-58.34614163163093, -34.60518560693015],
    [-58.346129774069766, -34.60536926018318],
    [-58.34616721464522, -34.605414650765454],
    [-58.34615251072972, -34.605638785201734],
    [-58.34611768538281, -34.60578184215825],
    [-58.346108734430516, -34.60600841555589],
    [-58.34608261631962, -34.606099006064255],
    [-58.346062196313255, -34.606294642783496],
    [-58.34595800895488, -34.606513910088836],
    [-58.34587409771137, -34.60670461582532],
    [-58.34573830907567, -34.60688336777315],
    [-58.34561986116762, -34.607009659568064],
    [-58.34520123934567, -34.60723105107212],
    [-58.34510594808097, -34.6073263504307],
    [-58.34492399724462, -34.607455014637196],
    [-58.344773877912075, -34.607524022315715],
    [-58.34460065769417, -34.60764791741741],
    [-58.34399736638534, -34.60794305872514],
    [-58.343604567696616, -34.60827654892353],
    [-58.343448645938224, -34.60837656702489],
    [-58.34322052390803, -34.60852421142317],
    [-58.343053047659964, -34.60865280008659],
    [-58.342677602289484, -34.60898639730436],
    [-58.34242339991994, -34.60919127006105],
    [-58.34220468120105, -34.60936353789691],
    [-58.34201916275413, -34.60946514869761],
    [-58.34171582592461, -34.60974868695229],
    [-58.34146470822964, -34.609870070247496],
    [-58.34127974736242, -34.61008213488259],
    [-58.34122478799355, -34.610208489630054],
    [-58.34086066059098, -34.610663641014185],
    [-58.34086319128323, -34.61090212773098],
    [-58.340842807249714, -34.611002280730645],
    [-58.340787668915766, -34.61125035871703],
    [-58.34075576186888, -34.61135762175678],
    [-58.34058194270244, -34.61187977173404],
    [-58.340442858051404, -34.61226842274948],
    [-58.34036180035679, -34.61246391018125],
    [-58.34029789093489, -34.61280250403229],
    [-58.34023092291869, -34.6132031277221],
    [-58.340051428130835, -34.61366567423141],
    [-58.339976109909514, -34.61387072415454],
    [-58.33993508193845, -34.61430707880862],
    [-58.339937591046976, -34.61455755798488],
    [-58.33985923581503, -34.614869899726045],
    [-58.33984450132266, -34.61504164865312],
    [-58.33984448513485, -34.615663242964274],
    [-58.339855428085514, -34.61611164133916],
    [-58.33999071130222, -34.61629544028227],
    [-58.34012905221397, -34.61641964385143],
    [-58.34052083826606, -34.61675147570003],
    [-58.34071977010126, -34.61690071639492],
    [-58.34082068932332, -34.61690442160176],
    [-58.341071548912794, -34.61697382678062],
    [-58.34120720085161, -34.6169692726138],
    [-58.34154760593725, -34.61694815203555],
    [-58.342162199026234, -34.61691296606051],
    [-58.34236989115749, -34.61691551563848],
    [-58.34261219010045, -34.61693487084756],
    [-58.342756411679034, -34.616975497721],
    [-58.34297560074333, -34.61699005234897],
    [-58.343145811829686, -34.617035573333],
    [-58.34329277634049, -34.617109654087244],
    [-58.343690729943205, -34.61722690229965],
    [-58.343999361081615, -34.61728446160856],
    [-58.34423609861699, -34.61735637769465],
    [-58.344289617271954, -34.617358504591266],
    [-58.34439168762623, -34.617375106076224],
    [-58.34443646936751, -34.617385429394005],
    [-58.34446010085293, -34.61740294369088],
    [-58.34453974391403, -34.61744107314695],
    [-58.34458452025939, -34.61745455218579],
    [-58.34468535674375, -34.617453570126145],
    [-58.344709001719025, -34.61746179892282],
    [-58.34501653388588, -34.61746931725514],
    [-58.3451086235641, -34.617483834111624],
    [-58.34532027990696, -34.61748305170141],
    [-58.34556067228715, -34.61738961034217],
    [-58.34565905991764, -34.61740205965731],
    [-58.345727495627386, -34.61741448109336],
    [-58.34577480356427, -34.61741867463206],
    [-58.345800895594834, -34.61741455303917],
    [-58.345833298168145, -34.61740069988235],
    [-58.34585700969319, -34.61736105057196],
    [-58.345945438231354, -34.617357081863815],
    [-58.34599523189439, -34.61732007386229],
    [-58.34607995702436, -34.617326289076914],
    [-58.34617575370805, -34.61732746539019],
    [-58.34624672190864, -34.61732951944174],
    [-58.34628034486201, -34.61734298678937],
    [-58.346341332386544, -34.61734304794328],
    [-58.34634752062152, -34.61735540642684],
    [-58.346346222899854, -34.617383174793645],
    [-58.34637480964972, -34.617460385188565],
    [-58.3463997046826, -34.617475828346755],
    [-58.34645068455143, -34.617491385718836],
    [-58.34650051688533, -34.617492428033074],
    [-58.34654281020249, -34.617481109165794],
    [-58.34655779110915, -34.6174461408267],
    [-58.34649940892052, -34.61738332677908],
    [-58.34650942017356, -34.61736485380493],
    [-58.34656662874687, -34.617364911361506],
    [-58.34657411290493, -34.61735148268474],
    [-58.34655553111281, -34.61732468558574],
    [-58.34657171890967, -34.61732677561014],
    [-58.34659526585881, -34.61734122591679],
    [-58.346606484001995, -34.61735972137399],
    [-58.34663139522269, -34.61736389332896],
    [-58.34666749670754, -34.61734129786254],
    [-58.34672102255712, -34.61733720324929],
    [-58.34672478172325, -34.61735064181863],
    [-58.34671108324983, -34.61737019397924],
    [-58.34667363817783, -34.61738863997374],
    [-58.34664994194122, -34.617416386756815],
    [-58.34663254095898, -34.61744522171955],
    [-58.34663743596883, -34.61748228457975],
    [-58.34666232110919, -34.617505933152245],
    [-58.34669639911948, -34.61751525282659],
    [-58.346822932832026, -34.61747011585311],
    [-58.34684704095815, -34.617469328946356],
    [-58.346938740330586, -34.61744137891645],
    [-58.34704335936351, -34.617437424597426],
    [-58.34704960065852, -34.61741164373234],
    [-58.34702472271272, -34.61738384928515],
    [-58.347088220245155, -34.6173901328483],
    [-58.34713429701014, -34.617373678852175],
    [-58.347177950102264, -34.617355148321394],
    [-58.34725632242129, -34.61733692176148],
    [-58.34729144814179, -34.61730458843596],
    [-58.347417059149905, -34.617276131188476],
    [-58.34749301768858, -34.6172465416945],
    [-58.347531652563646, -34.61721348981064],
    [-58.347603923881934, -34.61718371685498],
    [-58.34760466762128, -34.617166136008336],
    [-58.347637434419994, -34.61714885733386],
    [-58.34771825559301, -34.6171155761229],
    [-58.347807762418256, -34.61704650908911],
    [-58.3479174680167, -34.617006044093614],
    [-58.34799822983439, -34.61701568122868],
    [-58.34811367040953, -34.616991902254426],
    [-58.34821750613298, -34.6169682006219],
    [-58.34829257973871, -34.61692769785492],
    [-58.348390731746804, -34.61691588166258],
    [-58.3485313065745, -34.61692872038407],
    [-58.34856379278477, -34.61691837997921],
    [-58.34864745401677, -34.61691367472628],
    [-58.348739717264095, -34.61693287075536],
    [-58.34885223504256, -34.61694009411002],
    [-58.34891295277049, -34.61687342556809],
    [-58.349065931047846, -34.61682820855492],
    [-58.349144654102474, -34.61688219575666],
    [-58.34923026956125, -34.616960534800796],
    [-58.34958519869792, -34.61703911216523],
    [-58.349744865233276, -34.61710290917188],
    [-58.34980997884742, -34.61711027012285],
    [-58.3498547201192, -34.61715115420236],
    [-58.34994303714143, -34.61716178059163],
    [-58.349978455141525, -34.6171789441529],
    [-58.35004648705569, -34.617223003738616],
    [-58.350215082060345, -34.61720358827495],
    [-58.3502653280824, -34.61723050138647],
    [-58.350268091699036, -34.617382160358375],
    [-58.35029646710825, -34.61741834188291],
    [-58.35034486772145, -34.61748005695904],
    [-58.35051041672233, -34.61758533519503],
    [-58.35058123113885, -34.61770279205018],
    [-58.35055738561482, -34.61784225531579],
    [-58.35060162506488, -34.61798899229814],
    [-58.35066950319498, -34.61808201187529],
    [-58.35080961667046, -34.618171847852466],
    [-58.35035288967407, -34.6181355593086],
    [-58.35014566878755, -34.61824781088774],
    [-58.35004512278414, -34.618233115965495],
    [-58.349920904825865, -34.61816204614149],
    [-58.349793639964446, -34.618215760848614],
    [-58.349861536080994, -34.61836251941469],
    [-58.34991176321728, -34.61840413014647],
    [-58.34998267476061, -34.618448283261614],
    [-58.350101010253354, -34.61848012465799],
    [-58.350115643122365, -34.6185682294402],
    [-58.349971800158414, -34.61864158624019],
    [-58.349967558955655, -34.61871732084762],
    [-58.35024848917641, -34.61877869957726],
    [-58.35033744022064, -34.618653990589166],
    [-58.35040842460904, -34.61864431568256],
    [-58.350529839380556, -34.61852702879929],
    [-58.35072212432652, -34.61855163425048],
    [-58.350686491388444, -34.61862743091115],
    [-58.35054447135025, -34.61868356839193],
    [-58.35051167307523, -34.61872447405517],
    [-58.350396646188244, -34.61884167640221],
    [-58.35036953432649, -34.61893533180006],
    [-58.350440504325775, -34.61900382956304],
    [-58.35056767206038, -34.619022968035495],
    [-58.35066513159052, -34.61912629204471],
    [-58.35067694598422, -34.619170392999195],
    [-58.35082482240756, -34.619175392330476],
    [-58.35112563124284, -34.61930585608036],
    [-58.351211976051786, -34.619312785356726],
    [-58.351221599697055, -34.61931351380758],
    [-58.350867424192245, -34.619470448202605],
    [-58.35087442811232, -34.619613816324545],
    [-58.35077081362209, -34.61967151862564],
    [-58.350681918335795, -34.619553957449114],
    [-58.35015904170638, -34.619736617850606],
    [-58.34957211086419, -34.619790287591684],
    [-58.35082585033268, -34.61991397584927],
    [-58.35137788478153, -34.6196094051499],
    [-58.35173956333017, -34.61976169004993],
    [-58.35272941922727, -34.619894939899496],
    [-58.35387156002446, -34.61993301089967],
    [-58.35470913102154, -34.62021854744796],
    [-58.355813200818545, -34.61795330000473],
    [-58.3566507709163, -34.61823883475438],
    [-58.35760255491391, -34.61920965470176],
    [-58.357830983612985, -34.61922869065148],
    [-58.361771371251734, -34.62347364898966],
    [-58.362488065271975, -34.624325495824905],
    [-58.36343223470982, -34.625102152142574]
  ],
  // ID Nordelta: V1-D-1005152
  [
    [-58.63965299599994, -34.38141676999982],
    [-58.64406166199984, -34.38764423199984],
    [-58.64505913199969, -34.389014801999735],
    [-58.64513527499986, -34.38915947299989],
    [-58.64508197499998, -34.389235614999905],
    [-58.64139666499989, -34.39033207099993],
    [-58.63679764299985, -34.39164172599993],
    [-58.63715163325065, -34.39211719633556],
    [-58.639770274199975, -34.39569964141447],
    [-58.642825502131245, -34.394823999764355],
    [-58.64279694859954, -34.39474785701225],
    [-58.64445305345953, -34.39424341127898],
    [-58.64692681413237, -34.397695962942635],
    [-58.64743973499975, -34.398447872999895],
    [-58.64582550899996, -34.39895041499989],
    [-58.64632043699987, -34.399666156999956],
    [-58.64671204199993, -34.400192177999884],
    [-58.64859366199994, -34.4028082509999],
    [-58.64876461899996, -34.40310400299984],
    [-58.634358409999834, -34.407116725999856],
    [-58.62586849299964, -34.40955329399992],
    [-58.62659184899991, -34.412104075999764],
    [-58.626287277999836, -34.41419800199992],
    [-58.62541163699996, -34.416215783999974],
    [-58.62435594899955, -34.41742613699995],
    [-58.62401735400715, -34.41772915500832],
    [-58.629175669999825, -34.42155070599989],
    [-58.629305227999964, -34.42166157799983],
    [-58.62357072699996, -34.426563266999835],
    [-58.63023321799983, -34.43358267699995],
    [-58.63915619699986, -34.44283878099992],
    [-58.639395917999536, -34.44325936199982],
    [-58.65242863999998, -34.43478409599987],
    [-58.65804416799983, -34.431367189999946],
    [-58.66104876499992, -34.42852031199976],
    [-58.67115671599976, -34.419697269999915],
    [-58.67806666999968, -34.4135011539999],
    [-58.6794334329997, -34.41265025899975],
    [-58.67821134099984, -34.411944985999924],
    [-58.67816712300231, -34.41193945893161],
    [-58.67906460909779, -34.411275693173536],
    [-58.67943342555384, -34.411002055157894],
    [-58.67950480938407, -34.41068082792208],
    [-58.67936204172344, -34.410526162956785],
    [-58.678802868387265, -34.4103120114662],
    [-58.678596813999945, -34.41010804299992],
    [-58.678235135999955, -34.406948117999946],
    [-58.68140457799973, -34.402550873999814],
    [-58.66855168199987, -34.395600944999956],
    [-58.666814674999955, -34.398004199999946],
    [-58.66462557099993, -34.39679067499981],
    [-58.66041392499989, -34.40235861399998],
    [-58.65598812699989, -34.399836384999844],
    [-58.65143225299988, -34.39752037699998],
    [-58.65099443199989, -34.397406161999925],
    [-58.65105153899981, -34.397101590999966],
    [-58.65137514599985, -34.396854127999916],
    [-58.65194621599994, -34.3953693439999],
    [-58.65200332299969, -34.39449370199992],
    [-58.652039743955186, -34.394423729755204],
    [-58.65213654499996, -34.39455175699993],
    [-58.65226503599985, -34.394669539999825],
    [-58.655016881999984, -34.3961400469999],
    [-58.65731544099992, -34.3930883889999],
    [-58.65278057658031, -34.39068213335156],
    [-58.65293889886749, -34.39055259693487],
    [-58.65305073353488, -34.390483592565715],
    [-58.653176844968186, -34.390352722210366],
    [-58.65318287690428, -34.39025357259135],
    [-58.65313877359199, -34.39019329832303],
    [-58.6530245594638, -34.39014570910291],
    [-58.65300076485369, -34.39010287880484],
    [-58.652991247009425, -34.3900362538966],
    [-58.65305787191784, -34.389993423598526],
    [-58.65336244292661, -34.3898696916263],
    [-58.65362894255901, -34.389755477498],
    [-58.653785986985554, -34.38961270983765],
    [-58.653824058361636, -34.389517531397416],
    [-58.65390971895795, -34.389431870801104],
    [-58.65410959368245, -34.38933669236087],
    [-58.654780601686014, -34.38897501428812],
    [-58.65482819090613, -34.388622854059236],
    [-58.6549328871904, -34.38856098807304],
    [-58.655180351135016, -34.38857526483912],
    [-58.65526601173133, -34.388622854059236],
    [-58.65535957346373, -34.388546051445815],
    [-58.65462548899984, -34.3876329229999],
    [-58.65399731199983, -34.38647174599993],
    [-58.65217749999971, -34.38219252299996],
    [-58.65088687999986, -34.382717907999734],
    [-58.650761244999956, -34.38270648699995],
    [-58.65063560899995, -34.383037707999904],
    [-58.65027012399992, -34.383357506999914],
    [-58.6503158099996, -34.38388289199986],
    [-58.647631777999834, -34.38018235499982],
    [-58.64604420099994, -34.377955178999855],
    [-58.64405343799979, -34.37927258999986],
    [-58.64172346999993, -34.380551787999934],
    [-58.63965299599994, -34.38141676999982]
  ],
  // ID Belgrano: V1-C-1003652
  [
    [-58.4267588356517, -34.552019672369966],
    [-58.42906092921845, -34.55090033208461],
    [-58.430916908688346, -34.55111448314682],
    [-58.434533688778686, -34.55308943572885],
    [-58.43472404557821, -34.55347015022721],
    [-58.43408159239152, -34.55389845325095],
    [-58.43588998243672, -34.55487403241062],
    [-58.437650783057165, -34.55620653000733],
    [-58.44033957431185, -34.557277287117074],
    [-58.44112479577268, -34.55799112578978],
    [-58.4413627419969, -34.5586573750378],
    [-58.44114859093469, -34.55949018592332],
    [-58.44045854742399, -34.560489560244946],
    [-58.439268817202105, -34.56136995965585],
    [-58.43793631870608, -34.561774469316276],
    [-58.436936945283776, -34.56186964726635],
    [-58.43527132171408, -34.561798262679645],
    [-58.43481922532692, -34.561798262679645],
    [-58.43489060811504, -34.562083799227935],
    [-58.435247528350715, -34.56246451192766],
    [-58.43879292475361, -34.56239312913954],
    [-58.44137606725167, -34.56206571476088],
    [-58.441513123931486, -34.562598714159265],
    [-58.44244206604844, -34.563588570056424],
    [-58.442685722967724, -34.563588570056424],
    [-58.44778728735338, -34.56659620874797],
    [-58.44897909500918, -34.56783427393253],
    [-58.45234807860089, -34.56608992640895],
    [-58.45753340134536, -34.56909756510049],
    [-58.45784748956993, -34.569754295923985],
    [-58.46335875000625, -34.57501464910672],
    [-58.46734859496166, -34.57245564531172],
    [-58.46806674408492, -34.57289175804817],
    [-58.47216893504827, -34.568056694260974],
    [-58.473395985336424, -34.56667833483726],
    [-58.47134955463821, -34.565437751550974],
    [-58.46758810330829, -34.56298595593705],
    [-58.46646880439175, -34.56217884227971],
    [-58.4676718598684, -34.561683914780815],
    [-58.46700941834996, -34.56132604396174],
    [-58.46919336618089, -34.55890789288492],
    [-58.46648553987575, -34.55748973396402],
    [-58.46346362444666, -34.55589311537494],
    [-58.4611108127138, -34.55476239596777],
    [-58.45642657512627, -34.55224340301061],
    [-58.453106751175596, -34.55050734813557],
    [-58.4530781968013, -34.55049782971105],
    [-58.453243807855415, -34.550263691216344],
    [-58.4542146278028, -34.549372820998826],
    [-58.454197495717835, -34.54909870673987],
    [-58.453797746169016, -34.54848575761156],
    [-58.45018096517936, -34.54381820694465],
    [-58.449253926927156, -34.542598020282355],
    [-58.44655624137738, -34.53851448665421],
    [-58.446282387921826, -34.53866710070611],
    [-58.44570582986012, -34.53898900583789],
    [-58.44535719687707, -34.53918056323238],
    [-58.444822334982746, -34.539478668705556],
    [-58.44323462777584, -34.5403448579288],
    [-58.443155803997115, -34.54039146439453],
    [-58.443195244664764, -34.540433396184255],
    [-58.442998139352596, -34.540540485654844],
    [-58.44295878591919, -34.54049855386512],
    [-58.4428011338652, -34.54059636323154],
    [-58.442612208786386, -34.54068677297613],
    [-58.442474507292616, -34.54078269106827],
    [-58.44229439017391, -34.540866522272154],
    [-58.44175951119246, -34.54114596321557],
    [-58.442108628910034, -34.54087470160613],
    [-58.442397233945144, -34.540722360048846],
    [-58.442587724743646, -34.54047848819164],
    [-58.4426552458429, -34.540351453556696],
    [-58.44271055324941, -34.54019394179693],
    [-58.44284571595699, -34.54018882015788],
    [-58.44307903067266, -34.540112661070395],
    [-58.44324486655728, -34.539985639925305],
    [-58.44334311299423, -34.539899275331265],
    [-58.44345988456598, -34.53975195918554],
    [-58.44352129297323, -34.539629974243894],
    [-58.44352131365764, -34.53953340594188],
    [-58.443533655054125, -34.53941150373788],
    [-58.44359506795797, -34.539264182196234],
    [-58.44361962934238, -34.539142190959296],
    [-58.44375471740625, -34.539060878756516],
    [-58.44387756120045, -34.53908127268255],
    [-58.44396356966297, -34.53905080814826],
    [-58.443969692247435, -34.538999955983115],
    [-58.44402497177498, -34.53894406131934],
    [-58.44408637838359, -34.5388272142045],
    [-58.44420313286827, -34.5387408514091],
    [-58.44430136941264, -34.53869001003591],
    [-58.44441190688394, -34.53867478721162],
    [-58.44447095996679, -34.53862817894725],
    [-58.44458384466867, -34.53856814380475],
    [-58.44487161873019, -34.53846368035454],
    [-58.44494370298946, -34.53841599200439],
    [-58.44510223727838, -34.53836588088063],
    [-58.44524055300906, -34.538301520898415],
    [-58.445412944052066, -34.53816683573086],
    [-58.44552960140993, -34.53811599795489],
    [-58.44562785414212, -34.53797372970382],
    [-58.44581820104912, -34.53791280423246],
    [-58.44588580128868, -34.53781119612978],
    [-58.446033203769275, -34.537689220181335],
    [-58.44622353718643, -34.537699434681144],
    [-58.44649375288435, -34.537745184992275],
    [-58.44667177907928, -34.537735019955164],
    [-58.44687930303735, -34.53760466772121],
    [-58.44694816502573, -34.53747087108377],
    [-58.447077137699694, -34.53737936956219],
    [-58.447150847933244, -34.537267663871546],
    [-58.44729214311786, -34.537120263189536],
    [-58.44742721229596, -34.537105042163944],
    [-58.44771575707648, -34.53716098269314],
    [-58.44794302385145, -34.537171201689546],
    [-58.44807187062031, -34.53727788556591],
    [-58.44813944657818, -34.53729313267189],
    [-58.44813334917467, -34.53722199090214],
    [-58.44804736589316, -34.53712036211499],
    [-58.447955261825825, -34.53707463608555],
    [-58.44780646809397, -34.5369500979686],
    [-58.44782615425356, -34.536925666086574],
    [-58.44782615875016, -34.53689320595663],
    [-58.44778689704759, -34.536844512164464],
    [-58.44775248988543, -34.53678355521686],
    [-58.44762005122436, -34.53666578000173],
    [-58.44747278364201, -34.5365519716961],
    [-58.44733539781032, -34.536466747442375],
    [-58.447163317033414, -34.53641902581734],
    [-58.44700977218321, -34.53624624806588],
    [-58.44688082738821, -34.53619537701502],
    [-58.44671513089855, -34.53612935508562],
    [-58.44654313735589, -34.536103905171046],
    [-58.446426497085156, -34.53608360207653],
    [-58.44627912608075, -34.536063204553216],
    [-58.44609490895283, -34.536042893364765],
    [-58.445892268313514, -34.5360377258603],
    [-58.44571424301785, -34.53606312901013],
    [-58.445523815171896, -34.536098719680126],
    [-58.445315058243295, -34.53611392991388],
    [-58.44508787240733, -34.53616466336848],
    [-58.44480289703603, -34.53624920143943],
    [-58.44456240573038, -34.536314088424376],
    [-58.444429939190286, -34.53635473508291],
    [-58.44437098503289, -34.536366900212215],
    [-58.44426503320466, -34.53637797626254],
    [-58.44419134005824, -34.53639834410825],
    [-58.44405006465871, -34.53643889903594],
    [-58.44387814755845, -34.53646944181122],
    [-58.443681607020494, -34.536504941649696],
    [-58.4433622973321, -34.53660651557817],
    [-58.44320267396421, -34.53671325071588],
    [-58.443012228131806, -34.53680970210604],
    [-58.44290175990824, -34.536911394745005],
    [-58.442754361924244, -34.536997753943126],
    [-58.44258852873759, -34.537134873575496],
    [-58.44248229542154, -34.53719130423525],
    [-58.442385840434156, -34.537317792981696],
    [-58.44226916688848, -34.537429584108],
    [-58.44212787170386, -34.53754136983832],
    [-58.441974345739425, -34.537688680588076],
    [-58.441900634606554, -34.53777504967877],
    [-58.44177164124818, -34.53792245305874],
    [-58.44164265238646, -34.53804938966755],
    [-58.44158124937513, -34.53814594897631],
    [-58.441482886026336, -34.538344119985084],
    [-58.44137851520628, -34.53848638823621],
    [-58.441200328931984, -34.5387607381175],
    [-58.44103447506092, -34.53895890013308],
    [-58.44093619534908, -34.53917231015396],
    [-58.44088690890368, -34.53966523935924],
    [-58.44085621594155, -34.53985322914315],
    [-58.44083149897443, -34.54020892899882],
    [-58.44073936073289, -34.54029529629082],
    [-58.44061661226681, -34.54025461455876],
    [-58.44051829658207, -34.540249553174306],
    [-58.44040163292897, -34.5403054397442],
    [-58.44040166800255, -34.54017839611606],
    [-58.44038326427619, -34.54010725434625],
    [-58.440364886630164, -34.53993449368187],
    [-58.44027898968358, -34.539873439607504],
    [-58.44028514374435, -34.5397108718592],
    [-58.43992269897336, -34.540076716067574],
    [-58.439498997780504, -34.54030527606761],
    [-58.439351616883584, -34.54029505167523],
    [-58.43909984178424, -34.5401679477925],
    [-58.43892228683404, -34.540084593229324],
    [-58.43877015841605, -34.54002360390615],
    [-58.43851654510246, -34.54004581356338],
    [-58.43832002614823, -34.53996957713423],
    [-58.43806213835694, -34.53985770956558],
    [-58.43784115514518, -34.5398526068123],
    [-58.43765070661476, -34.53991351429721],
    [-58.437356030256524, -34.539918492044706],
    [-58.437194618137084, -34.539948118410905],
    [-58.43708172264337, -34.54001715666641],
    [-58.436999752136785, -34.540055637757405],
    [-58.4368523388643, -34.540152170086515],
    [-58.43663744406274, -34.540218119170845],
    [-58.4364716180707, -34.54027912198387],
    [-58.43626202657123, -34.540337860303964],
    [-58.43607542983716, -34.5404352838612],
    [-58.43593113901079, -34.54059908008344],
    [-58.435771393335074, -34.54075151157298],
    [-58.4356731118246, -34.540919195564356],
    [-58.43558094660335, -34.54107155420883],
    [-58.43543968289504, -34.54131541707278],
    [-58.435347490694085, -34.541549194040044],
    [-58.43525530029183, -34.54177783318039],
    [-58.43522449491445, -34.541991246798545],
    [-58.435150747808734, -34.54215379835904],
    [-58.43508310979763, -34.54232148864577],
    [-58.435034370140045, -34.54241308639479],
    [-58.435049073156165, -34.54252065610336],
    [-58.43489268375032, -34.54256182526797],
    [-58.43475921716413, -34.542591727726006],
    [-58.434603549014525, -34.54262856755429],
    [-58.4344589362309, -34.54266072191473],
    [-58.43428933398553, -34.54270666558011],
    [-58.43409474497645, -34.54276189024898],
    [-58.43390285123553, -34.54281937131691],
    [-58.43376883786152, -34.54286207742291],
    [-58.433746097604285, -34.542871449257916],
    [-58.43371239281265, -34.54288199021164],
    [-58.433681474120704, -34.54289334325313],
    [-58.43365190171386, -34.54290496699059],
    [-58.43362233110565, -34.5429163209314],
    [-58.43359257883441, -34.54292758404074],
    [-58.4335628283618, -34.542938848049346],
    [-58.433533166922075, -34.54295020199021],
    [-58.43350359541455, -34.542961735795416],
    [-58.433474203771425, -34.54297354119592],
    [-58.43344472129684, -34.542985344797785],
    [-58.43341523882219, -34.54299697033389],
    [-58.43338566821399, -34.543008684003496],
    [-58.43335627477222, -34.5430205793362],
    [-58.43332697396062, -34.543032563701786],
    [-58.43329785121483, -34.54304490869555],
    [-58.43326899826559, -34.54305761521675],
    [-58.433240594078086, -34.5430708631298],
    [-58.43321263865232, -34.54308474236694],
    [-58.43318540268416, -34.54309952272473],
    [-58.4331587063092, -34.543115114271075],
    [-58.43313236786446, -34.54313115817638],
    [-58.43310621018344, -34.543147381046765],
    [-58.43308005070372, -34.54316369474867],
    [-58.4330537131583, -34.543179828586176],
    [-58.43302701588402, -34.54319551096404],
    [-58.43299977991586, -34.54321047208555],
    [-58.4329720942867, -34.54322471105155],
    [-58.432943959895795, -34.543238591188015],
    [-58.43291564474117, -34.54325210799834],
    [-58.43288724055367, -34.54326562570799],
    [-58.432858927197685, -34.54327914521633],
    [-58.43283079280678, -34.543292932722636],
    [-58.43280301724542, -34.54330717168858],
    [-58.43277578037794, -34.543322042877946],
    [-58.43274899317146, -34.54333745455983],
    [-58.43272238582938, -34.5433531369377],
    [-58.43269595835176, -34.543369090011424],
    [-58.43266970983922, -34.54338522294961],
    [-58.43264364119102, -34.54340153665157],
    [-58.43261775240728, -34.5434181210494],
    [-58.43259195265642, -34.5434347962788],
    [-58.43256633277002, -34.54345156144035],
    [-58.432540802815765, -34.543468415634834],
    [-58.43251536369303, -34.54348536066084],
    [-58.43249001360323, -34.543502485551244],
    [-58.43246484427709, -34.54351970127317],
    [-58.43243976398389, -34.543537096859495],
    [-58.4324148617564, -34.54355458327734],
    [-58.43239014209132, -34.543572249559645],
    [-58.432365419728285, -34.54358991584189],
    [-58.43234078909609, -34.543607762887916],
    [-58.43231624659745, -34.54362560993388],
    [-58.432291705897455, -34.54364354691211],
    [-58.43226725512966, -34.54366148389033],
    [-58.43224280256322, -34.54367942086856],
    [-58.432218619793446, -34.5436975386105],
    [-58.43219461778733, -34.54371592704837],
    [-58.432170704814155, -34.543734405418434],
    [-58.43214688177312, -34.54375288288918],
    [-58.432123059631465, -34.543771361259246],
    [-58.43209914665823, -34.54378983962937],
    [-58.43205707367497, -34.54382580621592],
    [-58.432034239888196, -34.54384518570669],
    [-58.43201131526996, -34.54386447526525],
    [-58.43198838975235, -34.543883765723194],
    [-58.431965466033375, -34.54390305528176],
    [-58.43194263134734, -34.543922435671846],
    [-58.43191988569413, -34.54394190599413],
    [-58.431897320804694, -34.54396137721574],
    [-58.431874935779604, -34.543981118234],
    [-58.43185281965185, -34.54400094828509],
    [-58.43183097422002, -34.54402104993147],
    [-58.43180939678621, -34.54404133234158],
    [-58.43178826991266, -34.544061975379805],
    [-58.43176750186865, -34.54408279828249],
    [-58.43174700182266, -34.544103891881036],
    [-58.43172668433897, -34.54412507631116],
    [-58.4317066348533, -34.54414643970637],
    [-58.43168667529977, -34.54416789483241],
    [-58.431666804779184, -34.544189349059195],
    [-58.431646845225714, -34.54421080418524],
    [-58.43162688477287, -34.544232259311286],
    [-58.43160683618652, -34.54425353277429],
    [-58.43158651780351, -34.54427480713662],
    [-58.43156583879238, -34.544295810802964],
    [-58.43154507074837, -34.54431672363785],
    [-58.43152430180504, -34.54433763827137],
    [-58.43150371272611, -34.5443586410384],
    [-58.43148357420756, -34.544380006232245],
    [-58.431464063415774, -34.54440164122275],
    [-58.43144536201379, -34.544423726773516],
    [-58.431427379170145, -34.54444626378398],
    [-58.43140984508824, -34.544469072389745],
    [-58.431392759768016, -34.54449205906121],
    [-58.43137594604303, -34.5445153182273],
    [-58.43135949024821, -34.5445386682249],
    [-58.43134312528497, -34.54456219628827],
    [-58.431326939286805, -34.544585725250954],
    [-58.431310843220786, -34.544609255113016],
    [-58.43129465722262, -34.5446327840757],
    [-58.43127865108886, -34.54465631393771],
    [-58.43126291385238, -34.544680023664114],
    [-58.43124735737962, -34.54470382422204],
    [-58.43123206980414, -34.544727713812904],
    [-58.43121687216086, -34.54475169423523],
    [-58.43120194431424, -34.544775764589815],
    [-58.4311870155683, -34.5447998349444],
    [-58.43117208772162, -34.544823906198246],
    [-58.43115716077432, -34.54484788662063],
    [-58.43114223202832, -34.544871956975214],
    [-58.4311273041817, -34.54489602822906],
    [-58.43111246626728, -34.544920189415166],
    [-58.431097718285, -34.54494434880263],
    [-58.43108305933566, -34.54496850998868],
    [-58.43106849031852, -34.54499276110698],
    [-58.431054191997305, -34.54501701222529],
    [-58.43103998180965, -34.54504135327579],
    [-58.431025953285086, -34.54506578515782],
    [-58.43101219275843, -34.54509030697204],
    [-58.43099861299555, -34.54511491871847],
    [-58.430985122265554, -34.545139531364214],
    [-58.430971722367076, -34.5451642330429],
    [-58.4309584106021, -34.54518893472152],
    [-58.430945189668705, -34.54521363729947],
    [-58.430932148599766, -34.54523851974187],
    [-58.43091928829449, -34.54526340218422],
    [-58.430906606954295, -34.545288284626565],
    [-58.43089401374772, -34.54531325790049],
    [-58.430881693035644, -34.54533832110661],
    [-58.43086955038939, -34.54536347424488],
    [-58.430857676640414, -34.545388628282524],
    [-58.43084598275584, -34.54541387135305],
    [-58.430834469635045, -34.54543911532289],
    [-58.43082304734571, -34.54546453825782],
    [-58.4308118031222, -34.545489962092006],
    [-58.430800738763025, -34.54551538682557],
    [-58.43078994420051, -34.54554099142359],
    [-58.43077932860308, -34.54556659512224],
    [-58.43076898280225, -34.545592289652404],
    [-58.430758907697395, -34.54561807501409],
    [-58.430749282253544, -34.54564386127515],
    [-58.43073992480765, -34.54566982560192],
    [-58.430730927989885, -34.54569579082806],
    [-58.430722290001654, -34.54572184688567],
    [-58.430714190707306, -34.54574799287553],
    [-58.43070627217668, -34.5457742287976],
    [-58.43069862344265, -34.545800465618925],
    [-58.430691242706644, -34.54582679327183],
    [-58.43068413176724, -34.54585320905829],
    [-58.43067729242307, -34.54587971567628],
    [-58.430670632043984, -34.54590622319358],
    [-58.43066423966292, -34.54593272981157],
    [-58.43065802894483, -34.54595932726107],
    [-58.43065199719189, -34.545986014642835],
    [-58.43064614530334, -34.54601261209234],
    [-58.43064056231208, -34.546039301272685],
    [-58.430635070152334, -34.54606598775507],
    [-58.43062984688987, -34.546092585204576],
    [-58.430624713559666, -34.54611936431718],
    [-58.430619850925325, -34.546146050799564],
    [-58.43061525718832, -34.54617282901279],
    [-58.4306110222808, -34.54619960722607],
    [-58.430606968137056, -34.54622647627082],
    [-58.430603182890536, -34.54625334531556],
    [-58.430599576609154, -34.546280212561726],
    [-58.43059624192301, -34.54630717243799],
    [-58.430593085302576, -34.546334129616355],
    [-58.43059010944597, -34.5463610885933],
    [-58.430587311655074, -34.546388047570304],
    [-58.430584696426536, -34.54641500744657],
    [-58.430582169331615, -34.54644196642357],
    [-58.430579822101095, -34.54646892540052],
    [-58.43057765473492, -34.54649588437752],
    [-58.4305756672332, -34.54652284335447],
    [-58.43057376876436, -34.54654989226367],
    [-58.43057214189082, -34.54657685034135],
    [-58.43057051321858, -34.54660390014982],
    [-58.43056915524227, -34.54663094905902],
    [-58.43056788629889, -34.54665799886749],
    [-58.43056670728765, -34.54668504777669],
    [-58.430565708140875, -34.546712097585214],
    [-58.4305648888585, -34.54673914739368],
    [-58.430564158609, -34.54676619630288],
    [-58.430563520090345, -34.54679315527983],
    [-58.43056305963745, -34.54682020508835],
    [-58.430562780847595, -34.546847254896875],
    [-58.4305638483429, -34.54687511589384],
    [-58.43056680171651, -34.546903969742345],
    [-58.43057083607516, -34.54693327505055],
    [-58.430575228364035, -34.54696258035875],
    [-58.430579171891225, -34.54699152324014],
    [-58.430582216995674, -34.5470196558324],
    [-58.4305834652547, -34.54704643584432],
    [-58.430582287142784, -34.54707150084903],
    [-58.4305779641017, -34.54709431215275],
    [-58.43056798072769, -34.547113876004516],
    [-58.43046767214531, -34.54713341827261],
    [-58.42999621695179, -34.54682142187107],
    [-58.43005231756035, -34.54677373711826],
    [-58.42995490929161, -34.546734311739044],
    [-58.4299326088028, -34.54676252796827],
    [-58.42991049177573, -34.5467824497502],
    [-58.42988900337474, -34.54680273126098],
    [-58.42986787470261, -34.546823464231466],
    [-58.42984818404642, -34.54684500928971],
    [-58.42983028933634, -34.54686763623238],
    [-58.429813652777796, -34.54689098533066],
    [-58.42979746677963, -34.54691442526047],
    [-58.42978172864383, -34.546938224919074],
    [-58.429767519355494, -34.54696247603738],
    [-58.42975537670924, -34.54698753834418],
    [-58.429744671179606, -34.54701314294215],
    [-58.429734415310975, -34.547038838371634],
    [-58.42972361984914, -34.54706444207028],
    [-58.42971246465845, -34.547089956736045],
    [-58.42970274838308, -34.54711574119847],
    [-58.42969554841079, -34.54714206795205],
    [-58.42969077391007, -34.54716893609748],
    [-58.42968878640835, -34.54719589507448],
    [-58.429690573361256, -34.547222854950746],
    [-58.42969388826231, -34.54724981572639],
    [-58.42969765192504, -34.547276685670454],
    [-58.42970195518103, -34.547303557413215],
    [-58.42970544994654, -34.54733042735728],
    [-58.42970768566113, -34.547357476266484],
    [-58.42971216878152, -34.54738416634615],
    [-58.4297214156108, -34.54741004613669],
    [-58.4297325510164, -34.547435566198374],
    [-58.42974233743888, -34.547461445988915],
    [-58.42975275158818, -34.54748714501568],
    [-58.42976667399279, -34.54751149326074],
    [-58.42978455071642, -34.54753412919666],
    [-58.429802876201734, -34.547556585268126],
    [-58.42981778606196, -34.54758066281727],
    [-58.429829729958044, -34.54760591218303],
    [-58.42984364966463, -34.54763026132747],
    [-58.429862605574726, -34.54765226503997],
    [-58.429884077787904, -34.547672828038515],
    [-58.42990636029026, -34.547692669780815],
    [-58.42992945038378, -34.547711880199074],
    [-58.42995361966376, -34.547730099564376],
    [-58.429978237705484, -34.547748318929735],
    [-58.43000375686785, -34.54776554724219],
    [-58.43003098384281, -34.547779889630135],
    [-58.4300609987161, -34.54778954475165],
    [-58.430093171962255, -34.54779577435545],
    [-58.43012534520847, -34.54780191312773],
    [-58.430149277067414, -34.547737721318754],
    [-58.4300692149223, -34.54769370130322],
    [-58.430479188863444, -34.54733259562272],
    [-58.43060707605565, -34.54734804507615],
    [-58.430614706803226, -34.54737266221855],
    [-58.430618289702295, -34.54740079481081],
    [-58.430619626994144, -34.54743072964442],
    [-58.43062051372567, -34.54746039468142],
    [-58.4306224814423, -34.54748825567839],
    [-58.430624807988465, -34.54751521735335],
    [-58.43062677480577, -34.54754217633035],
    [-58.43062838189428, -34.54756922613882],
    [-58.43062972008545, -34.54759627594734],
    [-58.430630786681434, -34.54762332575581],
    [-58.43063167611092, -34.54765037556433],
    [-58.43063247470889, -34.54767742627217],
    [-58.43063309344245, -34.54770447518132],
    [-58.43063371217602, -34.54773152498984],
    [-58.430634420841784, -34.547758484866165],
    [-58.43063503867603, -34.54778553467463],
    [-58.430508747780436, -34.54782707076265],
    [-58.430390978860544, -34.547906478201355],
    [-58.43030215012408, -34.54798589283462],
    [-58.4302169951182, -34.54809524320086],
    [-58.430111977685556, -34.54820008076905],
    [-58.430023129164056, -34.5483304392983],
    [-58.42993615662829, -34.54848631429195],
    [-58.42983285060552, -34.54858213525728],
    [-58.429724134261335, -34.54872303833753],
    [-58.4296136291656, -34.54883986566722],
    [-58.429472282719644, -34.548985179022736],
    [-58.4293436212111, -34.54910651105661],
    [-58.42924041861039, -34.54916193807293],
    [-58.42916068291913, -34.54919942721176],
    [-58.429053811084486, -34.549217345304214],
    [-58.42899403944335, -34.54922337166124],
    [-58.42891621930801, -34.54918890964041],
    [-58.42882743373906, -34.54915435498947],
    [-58.428751405053276, -34.549136393729555],
    [-58.428711587569694, -34.54913782634958],
    [-58.428640943125004, -34.54914231756385],
    [-58.42859743842098, -34.54915285671893],
    [-58.42853585914253, -34.549184309608165],
    [-58.42850870321405, -34.549215770591275],
    [-58.428461585034086, -34.549269678652706],
    [-58.4284380200985, -34.549310157137995],
    [-58.42836368393682, -34.549328083324326],
    [-58.428298513665425, -34.549347542854775],
    [-58.42812755524244, -34.549158153725784],
    [-58.42796615841144, -34.54910085971687],
    [-58.4278422210416, -34.549093616577125],
    [-58.42766053910253, -34.54918662536244],
    [-58.4275769120448, -34.54928443382954],
    [-58.42749040805586, -34.54938215236439],
    [-58.42744427283486, -34.54944895400598],
    [-58.42743263920488, -34.54954191242928],
    [-58.427421082916624, -34.54966354213872],
    [-58.42741241255277, -34.54976137039091],
    [-58.42729421195827, -34.54978992386583],
    [-58.427233632725915, -34.549792343941476],
    [-58.427135703749684, -34.54970170397041],
    [-58.42698578676459, -34.54970166799751],
    [-58.42693106301812, -34.54967298232225],
    [-58.42687339039463, -34.549606246331166],
    [-58.426786937666975, -34.54957998432877],
    [-58.42668608859208, -34.54959419541575],
    [-58.42663413655612, -34.54959895462804],
    [-58.42657940381639, -34.54959415674489],
    [-58.42650445881367, -34.54956311394653],
    [-58.42636902720881, -34.54952970593115],
    [-58.42625659666459, -34.549512985735646],
    [-58.42618163997065, -34.549510525190556],
    [-58.42607782133433, -34.549532038772554],
    [-58.42595960455208, -34.54959159727434],
    [-58.42587023622241, -34.54966072366341],
    [-58.42582699322111, -34.54968694609562],
    [-58.42582406862584, -34.549796676875076],
    [-58.42580381139675, -34.54987538464127],
    [-58.42576055670429, -34.5499278456935],
    [-58.4257576536927, -34.549987444664794],
    [-58.42570577719982, -34.55002556602699],
    [-58.42567403382958, -34.55006135095056],
    [-58.42661450705384, -34.55176661843467],
    [-58.4267588356517, -34.552019672369966]
  ],
  // ID Caballito: V1-C-1003693
  [
    [-58.42672029790339, -34.62698866359591],
    [-58.426834512702555, -34.62699374026886],
    [-58.43383964598286, -34.62798359616596],
    [-58.445146843651855, -34.62969680826103],
    [-58.45157927336476, -34.630610799149],
    [-58.453048829439865, -34.627557474897515],
    [-58.454080563167395, -34.62550542793309],
    [-58.45462929800368, -34.62435059590325],
    [-58.45607601129882, -34.62119828597207],
    [-58.45764455125499, -34.617756633561726],
    [-58.4594392356322, -34.61390000338241],
    [-58.46212344124376, -34.60851757442646],
    [-58.46267880768079, -34.607332601618225],
    [-58.458419571705804, -34.60447724872603],
    [-58.446279260979054, -34.6075990149825],
    [-58.445755779105866, -34.60733727359627],
    [-58.439331234648705, -34.60562406240052],
    [-58.43332884365117, -34.60263277158509],
    [-58.43067688592953, -34.60603301471184],
    [-58.43038754434963, -34.60985538072117],
    [-58.43022003033008, -34.61201783475525],
    [-58.4301286592102, -34.61309906177223],
    [-58.430052516310525, -34.615474716285064],
    [-58.42929108821312, -34.615124459126434],
    [-58.429093116853835, -34.61600771478419],
    [-58.42851443189545, -34.61855088331657],
    [-58.42792051871692, -34.621368165208594],
    [-58.42743320487847, -34.62389610372219],
    [-58.42672029790339, -34.62698866359591]
  ],
  // ID Recoleta: V1-C-1003675
  [
    [-58.38033866359842, -34.57047200617808],
    [-58.38147734020703, -34.570533432571835],
    [-58.38070957368785, -34.57101942890347],
    [-58.37833814598861, -34.57228078562969],
    [-58.378326632867754, -34.57228654938473],
    [-58.3783125081157, -34.572296187419056],
    [-58.37830368936375, -34.57230429570666],
    [-58.3782979274074, -34.57231285815186],
    [-58.37829360616496, -34.572318716335644],
    [-58.3782917112934, -34.57232556737097],
    [-58.37828648533298, -34.57233710477351],
    [-58.37828476672854, -34.57234693166549],
    [-58.37824649607887, -34.572675377566554],
    [-58.37824809867078, -34.572690978106095],
    [-58.37825159163759, -34.572703422924576],
    [-58.378256075657305, -34.572713793906416],
    [-58.378261102867555, -34.572722544309954],
    [-58.37826783699103, -34.572730934085314],
    [-58.37827780597593, -34.57274112880003],
    [-58.378287059100444, -34.57274753736891],
    [-58.37829802003756, -34.57275457816121],
    [-58.37830871207734, -34.57276098583077],
    [-58.37832192401754, -34.572765323261024],
    [-58.378335945347544, -34.57276812824648],
    [-58.37835724758884, -34.572772108645836],
    [-58.37837801473353, -34.57277293512283],
    [-58.37840875985631, -34.5727755701364],
    [-58.37845496522442, -34.572780019082586],
    [-58.383524125238125, -34.573184285926004],
    [-58.38354687089134, -34.5731847508755],
    [-58.383565387932265, -34.57318773932269],
    [-58.3835755430768, -34.57319234385153],
    [-58.383583987710836, -34.57319748887295],
    [-58.383590186737706, -34.57320290279171],
    [-58.38359584437268, -34.57320939859483],
    [-58.38360015302459, -34.57321679461933],
    [-58.38360239323583, -34.57322437140755],
    [-58.38360211444598, -34.57323464885991],
    [-58.3836003940429, -34.57324745160855],
    [-58.3835886695814, -34.573380348024614],
    [-58.3835864131824, -34.57339035388168],
    [-58.38358487803964, -34.57339765727602],
    [-58.38358361269354, -34.5734037870551],
    [-58.38358063863552, -34.57341154011044],
    [-58.38357236037609, -34.57341946763427],
    [-58.38356219533898, -34.57342631417299],
    [-58.38355239093005, -34.57343117590801],
    [-58.38354303618212, -34.573436490001995],
    [-58.38189086467162, -34.57437481474585],
    [-58.381880698735245, -34.574383102897855],
    [-58.38186801559641, -34.5743888648542],
    [-58.38185650157624, -34.57439525993328],
    [-58.38184435892998, -34.57440219370625],
    [-58.38183563370751, -34.57440633688287],
    [-58.38182951921692, -34.574407595034415],
    [-58.38182223470835, -34.57440885228664],
    [-58.38181171533836, -34.5744101068409],
    [-58.38179373699131, -34.574407479921206],
    [-58.38176685895331, -34.57440376482185],
    [-58.376113303286274, -34.57395294277404],
    [-58.37551422979783, -34.573905565589314],
    [-58.37543850957951, -34.57392517080996],
    [-58.37329504383115, -34.57515571676288],
    [-58.3707608145599, -34.576597831824415],
    [-58.370756047253735, -34.576600442556355],
    [-58.37074938867329, -34.57660530698928],
    [-58.37074533902614, -34.57660900140422],
    [-58.37074227503592, -34.57661494862094],
    [-58.37073984057116, -34.576621259163744],
    [-58.370739203851144, -34.576627931233986],
    [-58.370695801669854, -34.57701515592464],
    [-58.370695702744456, -34.5770236311356],
    [-58.37069767315904, -34.57703057480114],
    [-58.37069982343809, -34.577037248670024],
    [-58.37070350436318, -34.57704194133248],
    [-58.37070871143783, -34.5770492483241],
    [-58.37071733503694, -34.57705565599366],
    [-58.37072659175874, -34.5770594511327],
    [-58.37073593931211, -34.577061981824954],
    [-58.370744300309184, -34.57706225881617],
    [-58.37075284027134, -34.57706343782735],
    [-58.3707692016373, -34.57706453320162],
    [-58.376005084267206, -34.577478775325176],
    [-58.37601641122836, -34.57748004516793],
    [-58.37602558071592, -34.57748077182009],
    [-58.37603582938999, -34.57748195083133],
    [-58.37604095192836, -34.577483938333046],
    [-58.37606735872157, -34.57750884056048],
    [-58.37605229507733, -34.577642817062326],
    [-58.37604622105624, -34.577691411029775],
    [-58.376043420567385, -34.57770340079128],
    [-58.37603999684836, -34.5777108831507],
    [-58.37603567560592, -34.57771628897552],
    [-58.37602730741429, -34.577722685853246],
    [-58.37601588062836, -34.57773016191737],
    [-58.374956849778755, -34.57832995216552],
    [-58.374321351049446, -34.57868990041851],
    [-58.374313613282595, -34.57869539437689],
    [-58.37430371894146, -34.5786997138207],
    [-58.37429184609181, -34.5787034918726],
    [-58.374283484195416, -34.578704116002086],
    [-58.37427260509662, -34.57870428867193],
    [-58.37426406513447, -34.57870310966075],
    [-58.37381933599352, -34.57909275982297],
    [-58.37517086864062, -34.58067272296773],
    [-58.3763891532368, -34.58006358066967],
    [-58.37991075627633, -34.580253936569875],
    [-58.38091964722389, -34.579854187920375],
    [-58.383394287416365, -34.578635904223574],
    [-58.383889214915314, -34.578654940173294],
    [-58.38650548304156, -34.57803349065301],
    [-58.38672035356143, -34.57806112142356],
    [-58.38994119273184, -34.57825147822308],
    [-58.39029144899115, -34.57875402028179],
    [-58.391616332927356, -34.580825103195934],
    [-58.389103621734705, -34.58202815867253],
    [-58.38765691023815, -34.582964715349306],
    [-58.38678888280066, -34.583733756207835],
    [-58.385372627744516, -34.5854317400827],
    [-58.384854856566335, -34.58623885284072],
    [-58.38448937208682, -34.58689368069878],
    [-58.383849773348345, -34.58747998021687],
    [-58.38383454422882, -34.587700794356124],
    [-58.38487008478654, -34.588713492133934],
    [-58.38573811312341, -34.589581519571425],
    [-58.386781269140215, -34.59058660368879],
    [-58.38796148093758, -34.59160691692563],
    [-58.38785488069817, -34.59169828804551],
    [-58.387539, -34.59288],
    [-58.3828877964346, -34.59287313538687],
    [-58.38283127674197, -34.594286107917526],
    [-58.38282722709482, -34.59438735089549],
    [-58.38278693836645, -34.59539456910403],
    [-58.38264701734596, -34.59796243032184],
    [-58.38641417757219, -34.598199277574565],
    [-58.386991, -34.598234],
    [-58.386927703950334, -34.59932914982039],
    [-58.39270979432149, -34.599614684569985],
    [-58.394660951741514, -34.59966227399468],
    [-58.39856326838009, -34.59978124710682],
    [-58.402013486832914, -34.59937673924509],
    [-58.404535714651445, -34.59802044558705],
    [-58.40991329716087, -34.59809183017376],
    [-58.41190216495289, -34.59800149507288],
    [-58.41598730027363, -34.59784068909647],
    [-58.414407338028184, -34.59405258725707],
    [-58.41301773168294, -34.59247262501157],
    [-58.410181414740464, -34.58914137877156],
    [-58.4080303820964, -34.586152776029735],
    [-58.406145849151585, -34.583430672987106],
    [-58.40209124671361, -34.583430672987106],
    [-58.401215605615675, -34.58386849443542],
    [-58.40056839231744, -34.58447763583416],
    [-58.40008298234375, -34.58384549157614],
    [-58.399416733095734, -34.582931778578654],
    [-58.399207341245756, -34.58245588702954],
    [-58.39793194969968, -34.58041906918464],
    [-58.39659930101686, -34.57853401463302],
    [-58.39857916299792, -34.577163965844306],
    [-58.40128223099015, -34.575679182448255],
    [-58.402633765435894, -34.57412777367779],
    [-58.399721303795104, -34.57087267123677],
    [-58.3995404654201, -34.57036854277396],
    [-58.40006930905133, -34.56914289362959],
    [-58.40004529175678, -34.56916127397358],
    [-58.40002118632867, -34.569179564385365],
    [-58.399997079101865, -34.569197674033376],
    [-58.399972881942915, -34.56921569284992],
    [-58.39996217911124, -34.56922362217239],
    [-58.39956100413701, -34.568807193796886],
    [-58.399527227399574, -34.56877318233643],
    [-58.39946515439334, -34.56871174515089],
    [-58.39936616331772, -34.568609531804384],
    [-58.39891953660731, -34.568151331718525],
    [-58.39865535715899, -34.56787744229007],
    [-58.39842944296436, -34.56764441895473],
    [-58.39835497640098, -34.5675686375825],
    [-58.39818331560747, -34.56739533372763],
    [-58.39805989264988, -34.567271196708305],
    [-58.397989289574014, -34.56719947577517],
    [-58.39785230663858, -34.56705748001866],
    [-58.397603225908085, -34.566796310601205],
    [-58.39759190973882, -34.566783050996946],
    [-58.39757403481383, -34.56676347455465],
    [-58.397561279729246, -34.566750303983326],
    [-58.39752561891214, -34.56671520973907],
    [-58.39750450912578, -34.56669608295783],
    [-58.397487797923475, -34.566681826904755],
    [-58.39747450324569, -34.56667099996662],
    [-58.39744862705248, -34.56665141992704],
    [-58.39742068511646, -34.566632197817626],
    [-58.39740720607767, -34.56662443576903],
    [-58.397389592855404, -34.56661622226079],
    [-58.39737898804981, -34.56661206829227],
    [-58.39736631660219, -34.56660764272851],
    [-58.39734879061416, -34.56660231334604],
    [-58.39733953299299, -34.56659987438468],
    [-58.39731256862012, -34.566594448774765],
    [-58.39728955676759, -34.56659191178727],
    [-58.397272566775484, -34.566591451334375],
    [-58.397252968749456, -34.56659207096726],
    [-58.39723777560283, -34.5665931447578],
    [-58.397225998081296, -34.56659431027913],
    [-58.397204150850825, -34.566597634173434],
    [-58.39719381224461, -34.566599791647036],
    [-58.39715038308367, -34.56661094773699],
    [-58.39708986770319, -34.56662921656505],
    [-58.3970432000836, -34.56664451942896],
    [-58.39700381427457, -34.56665856324207],
    [-58.396978814021, -34.5666688281039],
    [-58.39695066703962, -34.56668251668475],
    [-58.3968901390686, -34.56671593369333],
    [-58.396877639391505, -34.566722238840214],
    [-58.39677853769933, -34.566766364076386],
    [-58.396687530804854, -34.566806526899654],
    [-58.396568017200195, -34.56686001677633],
    [-58.396537261285516, -34.56687415681682],
    [-58.39653006491051, -34.566877939365384],
    [-58.396521432318195, -34.566883254358686],
    [-58.39651684397711, -34.56688649731393],
    [-58.39650829771972, -34.56689361634727],
    [-58.39649255508732, -34.56690884366816],
    [-58.396449729371454, -34.566952911347755],
    [-58.39631755601039, -34.56709592873409],
    [-58.396259431927206, -34.567159463138694],
    [-58.396238918391305, -34.567182714210844],
    [-58.39621516190016, -34.567210651650214],
    [-58.39619977539928, -34.56723002934234],
    [-58.39616881803647, -34.567271126561195],
    [-58.39605614197734, -34.567425605807045],
    [-58.396007002121394, -34.56749780068293],
    [-58.395935446663486, -34.567604876663665],
    [-58.39586866480698, -34.567702938739615],
    [-58.39584796511144, -34.567732592984726],
    [-58.395830956233624, -34.567755213632154],
    [-58.395781710257666, -34.56773309570576],
    [-58.39574696584975, -34.56778645428142],
    [-58.39579468477683, -34.56780785095151],
    [-58.39575157397593, -34.56787094199035],
    [-58.395684882051626, -34.5679668402974],
    [-58.3955958707528, -34.568093831764884],
    [-58.3954060544458, -34.56836981211711],
    [-58.395249350277254, -34.56860613686371],
    [-58.39524313686121, -34.56861821475877],
    [-58.395234849608585, -34.56863876876412],
    [-58.39522980441188, -34.56865391424668],
    [-58.39522169072842, -34.56868068796331],
    [-58.39521555825138, -34.56870557040571],
    [-58.39521167677742, -34.568724502933435],
    [-58.395205627038024, -34.56875822121492],
    [-58.39520426996103, -34.568768588599426],
    [-58.39520272582507, -34.56878725312919],
    [-58.395202628698314, -34.56879599903607],
    [-58.39520440485933, -34.56882277904799],
    [-58.39520876926923, -34.56887453593106],
    [-58.39521258868996, -34.568930349655886],
    [-58.39521392957914, -34.56893972778619],
    [-58.39521392688118, -34.56894333496689],
    [-58.395213204725565, -34.56894703118053],
    [-58.395212123740464, -34.56894946474597],
    [-58.39521023426488, -34.56895280033143],
    [-58.39520744366854, -34.56895631488197],
    [-58.39520528529562, -34.568958657615894],
    [-58.39520114571627, -34.568962352930214],
    [-58.3951893618995, -34.56897136233846],
    [-58.39518009618445, -34.568979472424644],
    [-58.39509029977745, -34.56907418542528],
    [-58.39501814087447, -34.56914871134393],
    [-58.39494643433045, -34.56921954104894],
    [-58.39492555926711, -34.569242070864846],
    [-58.39491530159984, -34.56925180242871],
    [-58.394912875228954, -34.56925270175077],
    [-58.39491116561777, -34.56925297244669],
    [-58.39488646214045, -34.569230598213494],
    [-58.39485969202116, -34.569205517020976],
    [-58.3948509766912, -34.56919911025068],
    [-58.39483947616088, -34.56919261085028],
    [-58.39482590629052, -34.569186292213544],
    [-58.39476982906433, -34.56916200692103],
    [-58.39475518000751, -34.569156859201655],
    [-58.3947507751281, -34.569155683787756],
    [-58.39474178730359, -34.56915378621824],
    [-58.39473189925769, -34.56915242824192],
    [-58.39472102195754, -34.569151789723264],
    [-58.394713289586605, -34.569151786125985],
    [-58.394705827911594, -34.56915196239311],
    [-58.39469405128938, -34.56915276728631],
    [-58.39468164424244, -34.569154201704976],
    [-58.394664739685936, -34.56915770996028],
    [-58.3946511617217, -34.5691619403712],
    [-58.39464486736671, -34.569164371238685],
    [-58.39463074711125, -34.56917121597877],
    [-58.394617974939536, -34.569178781975154],
    [-58.394609700277385, -34.569184728292555],
    [-58.39459773479757, -34.56919409922824],
    [-58.394586399742536, -34.569203830792105],
    [-58.39457560428065, -34.56921410284855],
    [-58.39456183655949, -34.569228702442615],
    [-58.39281018114491, -34.572201274768986],
    [-58.392789923915814, -34.572235527247756],
    [-58.38805865718126, -34.5748088284646],
    [-58.386760343714855, -34.57326152869655],
    [-58.39130160078821, -34.57064327486722],
    [-58.39132428528751, -34.57060911501861],
    [-58.391338705017176, -34.570568007907184],
    [-58.39133072892997, -34.5705382493407],
    [-58.391314486274496, -34.57050379721244],
    [-58.39104479488134, -34.5700712134157],
    [-58.39097903915132, -34.57001283932101],
    [-58.39090374880891, -34.56995833680776],
    [-58.39080506260353, -34.5699310513769],
    [-58.39066391310905, -34.569938727090516],
    [-58.390424113382096, -34.56941508603734],
    [-58.38380921212541, -34.56886780990146],
    [-58.383785416963406, -34.56867745310194],
    [-58.38121559972012, -34.56841571171566],
    [-58.38097765349585, -34.568629863677245],
    [-58.38064452842218, -34.57010512954804],
    [-58.380382787935275, -34.57010512954804],
    [-58.380477966784724, -34.56851089056511],
    [-58.37250677187001, -34.567844641317095],
    [-58.37250677187001, -34.568034998116616],
    [-58.37695636464446, -34.56843950687772],
    [-58.376668438597505, -34.57150476783073],
    [-58.37611506775613, -34.57181648094581],
    [-58.37587668805867, -34.571950577956784],
    [-58.375846461844674, -34.57196913186988],
    [-58.37581803337548, -34.57198768578303],
    [-58.37577718976547, -34.572014617780326],
    [-58.37427757115296, -34.57299585187701],
    [-58.37422953566448, -34.57302088090887],
    [-58.37419238287214, -34.57304231085391],
    [-58.37414389682334, -34.573069684418385],
    [-58.374095319943024, -34.57309705708349],
    [-58.37401489806905, -34.57314243687392],
    [-58.37397216858068, -34.57316593795764],
    [-58.37163133941476, -34.57449802366483],
    [-58.37156935364271, -34.57453539499244],
    [-58.37151708594473, -34.5745656490854],
    [-58.37147354616718, -34.5745889676067],
    [-58.37142388830176, -34.57461715056098],
    [-58.37137728903065, -34.57464290174846],
    [-58.37132843875639, -34.57467162699396],
    [-58.371287685977904, -34.574695578638],
    [-58.37124828038378, -34.574720074371896],
    [-58.371216972285424, -34.57473952490909],
    [-58.3711783733832, -34.57476690476881],
    [-58.37114705898955, -34.574791675695224],
    [-58.371122402277024, -34.57481203364841],
    [-58.371100800561464, -34.574834558967666],
    [-58.371079829270684, -34.574855911571035],
    [-58.37106182844059, -34.574875013171265],
    [-58.37103797032603, -34.57490411793066],
    [-58.37100699317813, -34.574949175763834],
    [-58.370980687108954, -34.57499838576683],
    [-58.37096653807521, -34.5750292109293],
    [-58.37095004091162, -34.57506977305155],
    [-58.3709397607613, -34.57509762595464],
    [-58.37093200141072, -34.57512250479971],
    [-58.37092486259229, -34.575154868702214],
    [-58.37091989833459, -34.57517334887092],
    [-58.370913106654484, -34.57521779516509],
    [-58.370905505584574, -34.57526205979616],
    [-58.37089497991934, -34.57535005306244],
    [-58.370886180053105, -34.57542199792681],
    [-58.370871110113626, -34.575554529218095],
    [-58.37096622601047, -34.575558749736444],
    [-58.37098145692863, -34.5754431697664],
    [-58.37099589464481, -34.575313343635855],
    [-58.37100360093541, -34.57525447311542],
    [-58.37101435772638, -34.57520227466517],
    [-58.37102573774757, -34.57515485791032],
    [-58.37103837142365, -34.57511321120569],
    [-58.37104865067465, -34.57508445628258],
    [-58.371062623441276, -34.57505092595943],
    [-58.37107649998046, -34.57502217283496],
    [-58.37109028029215, -34.574999373222454],
    [-58.37110324761676, -34.574980537821546],
    [-58.37111657736813, -34.57495863932968],
    [-58.37112945206252, -34.57494250908945],
    [-58.371147728085134, -34.57491971217496],
    [-58.37116932980069, -34.57489745665225],
    [-58.371190028596914, -34.57487862934522],
    [-58.371211086222615, -34.57485998190259],
    [-58.37124347980273, -34.574835300908376],
    [-58.3712684036139, -34.574816746995225],
    [-58.37129638512005, -34.57479774342107],
    [-58.37133129140591, -34.574775951049276],
    [-58.371372045983094, -34.57475154794554],
    [-58.37141306855824, -34.57472732380688],
    [-58.371466683440644, -34.57469869388956],
    [-58.37153955460673, -34.574654568653386],
    [-58.37160063566074, -34.57462179735802],
    [-58.37421432093413, -34.57312573196691],
    [-58.37425039364069, -34.573105472939176],
    [-58.374279090107905, -34.57308935528948],
    [-58.37579533178911, -34.572118410336316],
    [-58.37582412268506, -34.572096339174664],
    [-58.37585435699293, -34.57207165368385],
    [-58.37588089508722, -34.5720549020121],
    [-58.3759132805734, -34.57203472572195],
    [-58.37594818596, -34.57201283892135],
    [-58.375979220664476, -34.57199518792754],
    [-58.376012414641195, -34.57197528323269],
    [-58.37605343271969, -34.571954032252734],
    [-58.376081587795, -34.5719384523976],
    [-58.37610533439363, -34.571926925786954],
    [-58.37611585466294, -34.57192431865235],
    [-58.37854666999277, -34.57054551586282],
    [-58.37859650412531, -34.57051669798716],
    [-58.37863644121876, -34.57049580583674],
    [-58.37867943420849, -34.57047509714795],
    [-58.37870983489091, -34.57046123140066],
    [-58.378743473132715, -34.570445565210605],
    [-58.37879976979349, -34.570426397959864],
    [-58.3788378084181, -34.57041605395767],
    [-58.37886937192394, -34.57040769026264],
    [-58.37891433173098, -34.570398432641525],
    [-58.37895137660473, -34.570391515056315],
    [-58.378989051003884, -34.5703857701871],
    [-58.37905297571422, -34.57037941108092],
    [-58.379092444260834, -34.57037844520903],
    [-58.37913937268388, -34.57037838585376],
    [-58.37918503935805, -34.57038085179482],
    [-58.3792459873124, -34.570385309734206],
    [-58.38033866359842, -34.57047200617808]
  ],
  // ID Villa Urquiza: V1-C-1003657
  [
    [-58.473395985336424, -34.56667833483726],
    [-58.47216893504827, -34.568056694260974],
    [-58.46806674408492, -34.57289175804817],
    [-58.46910418940678, -34.57351993629595],
    [-58.472644826597445, -34.57549964809027],
    [-58.475385965589794, -34.577079610335716],
    [-58.47842215865563, -34.57878330400621],
    [-58.481515457772105, -34.5806202484257],
    [-58.48344758014167, -34.58174335327311],
    [-58.48871987272389, -34.584812323030235],
    [-58.48877662084436, -34.584850929127015],
    [-58.49041749686995, -34.58339850603619],
    [-58.492033627150136, -34.58201651515003],
    [-58.49299492957232, -34.58120749942651],
    [-58.49348985797053, -34.58083630335267],
    [-58.495774139564844, -34.579142127207376],
    [-58.49703049606052, -34.5781332353605],
    [-58.50001909880234, -34.57580136344211],
    [-58.501389668298486, -34.574735364645335],
    [-58.50305529096886, -34.573450455574005],
    [-58.50591064386106, -34.57180386885341],
    [-58.50911815687738, -34.570014513858666],
    [-58.50947853590566, -34.56969746236797],
    [-58.508540165296324, -34.5692918762191],
    [-58.491922009593054, -34.561296887041635],
    [-58.49099116540992, -34.56266745743716],
    [-58.485988585804535, -34.560268960144356],
    [-58.48356203595915, -34.55910571675537],
    [-58.48119366955217, -34.56238119243801],
    [-58.4808890988528, -34.56270860591741],
    [-58.48023351016832, -34.56316945990261],
    [-58.48031917059319, -34.56334078075241],
    [-58.48007361070853, -34.563494970416514],
    [-58.479685281650404, -34.56368913404623],
    [-58.4791142121511, -34.56392898413526],
    [-58.479223751375, -34.5640945870955],
    [-58.47778133324192, -34.56542975657794],
    [-58.476222691224166, -34.56681593560688],
    [-58.47517953520736, -34.56619917964838],
    [-58.47428866498984, -34.56721949288527],
    [-58.473395985336424, -34.56667833483726]
  ],
  // ID Núñez: V1-C-1003697
  [
    [-58.456655031704315, -34.5275528184078],
    [-58.456487809964415, -34.52759338772461],
    [-58.45636677290821, -34.52762674717661],
    [-58.45627170557469, -34.5276482041013],
    [-58.456185263638986, -34.52767209459142],
    [-58.45614491735404, -34.52769833231213],
    [-58.45609253004619, -34.52771131492523],
    [-58.456009406608814, -34.527815183923565],
    [-58.455943176036726, -34.5279130121757],
    [-58.4559143239868, -34.5280155285937],
    [-58.45588260040165, -34.52808468555975],
    [-58.45587396691002, -34.52817052405038],
    [-58.45588546024578, -34.528261229671955],
    [-58.455931546903344, -34.52837565221455],
    [-58.455951755569004, -34.528483040260085],
    [-58.45597771899651, -34.528547419128074],
    [-58.455914270926826, -34.528669049736834],
    [-58.455847954919136, -34.5286976319901],
    [-58.4557903542414, -34.52875488463019],
    [-58.45572260021777, -34.52877904761493],
    [-58.455649094130365, -34.52881925900158],
    [-58.45555402409889, -34.528847930287725],
    [-58.45543873460986, -34.52890274756368],
    [-58.455257668706395, -34.52896712193507],
    [-58.45508711497831, -34.52904826596466],
    [-58.45499491828082, -34.52910308503931],
    [-58.45493722587224, -34.52914843695078],
    [-58.45487962339587, -34.52921281402013],
    [-58.454778704173805, -34.529310639574305],
    [-58.45464040193298, -34.529446517242945],
    [-58.454510727787806, -34.52956345788721],
    [-58.45445878384578, -34.5296301785898],
    [-58.4543954302049, -34.529682654031205],
    [-58.45433773779632, -34.52972079337985],
    [-58.45425129136396, -34.5297757023867],
    [-58.454156215936564, -34.52983051966271],
    [-58.454071295653705, -34.52988389622476],
    [-58.454029326991815, -34.529937904110966],
    [-58.45401206810243, -34.5299998467155],
    [-58.4539832223478, -34.53002851890096],
    [-58.45396884038962, -34.53007378177955],
    [-58.45390539411858, -34.53013103621828],
    [-58.453908262056586, -34.53020262674977],
    [-58.45383043112946, -34.53033381715187],
    [-58.453781447755546, -34.530445890665305],
    [-58.45374684544055, -34.53051982572936],
    [-58.45372383808461, -34.53054362898524],
    [-58.453654630756546, -34.53070105710805],
    [-58.45359405871881, -34.5307749921721],
    [-58.45356241697192, -34.530882378418994],
    [-58.45356527681605, -34.531023035984276],
    [-58.4535767629572, -34.53116856427778],
    [-58.45357100190017, -34.53125917996715],
    [-58.4535623666099, -34.53134033029198],
    [-58.45358248804138, -34.53140470915997],
    [-58.45365166928906, -34.53150010474599],
    [-58.45372948043115, -34.531564486311936],
    [-58.453807288875225, -34.531643203071326],
    [-58.453954282164375, -34.53179820212529],
    [-58.454023376177815, -34.53187213898798],
    [-58.454075310227324, -34.53191271460008],
    [-58.45416749973026, -34.53196997263609],
    [-58.454239558808524, -34.53205103302872],
    [-58.45430002922291, -34.53210829106473],
    [-58.45436346380279, -34.5321607692041],
    [-58.45447299763072, -34.53220369024808],
    [-58.45455889727526, -34.532275103613074],
    [-58.45467669677208, -34.53233605876204],
    [-58.454778410994834, -34.53240882470743],
    [-58.454868086892645, -34.532449761846976],
    [-58.454928290208386, -34.53248276516746],
    [-58.45499747865068, -34.532520997146264],
    [-58.455064329754975, -34.53256752357231],
    [-58.45513801031086, -34.53263253556304],
    [-58.45519057298651, -34.532673561735464],
    [-58.45523612904407, -34.53270971987763],
    [-58.45530585528098, -34.53278329701152],
    [-58.45539229272009, -34.53285489114029],
    [-58.455471726239125, -34.532896550435396],
    [-58.45560839621049, -34.53298608693831],
    [-58.45566033026, -34.533038565077675],
    [-58.455697798714425, -34.53307670712428],
    [-58.45574613187847, -34.53321754725198],
    [-58.45574100124617, -34.53332709816698],
    [-58.45571215099494, -34.53338913070377],
    [-58.45566604904889, -34.533427270052414],
    [-58.455602600079885, -34.533515541209226],
    [-58.45553627687764, -34.53358469637658],
    [-58.45545557441517, -34.53367296573475],
    [-58.455371995021494, -34.533763581424125],
    [-58.45525094357612, -34.53385662798098],
    [-58.455147237355106, -34.533942462874336],
    [-58.45508666261935, -34.53402117603639],
    [-58.455037679245436, -34.534121348821145],
    [-58.45500594486845, -34.534264441750565],
    [-58.45501168793902, -34.53435271380664],
    [-58.45502614813819, -34.53443377419927],
    [-58.45504914740019, -34.53449580763538],
    [-58.45510098971886, -34.53457452439471],
    [-58.45512120288117, -34.53463890326276],
    [-58.455100976229005, -34.53472239632151],
    [-58.45507509194192, -34.53477487176286],
    [-58.45504048872755, -34.53483446983489],
    [-58.454994384083534, -34.53489172517294],
    [-58.45496841076351, -34.53492986362227],
    [-58.454925181252065, -34.534989553425135],
    [-58.454905042733515, -34.53508972710915],
    [-58.45492498519985, -34.53516429439662],
    [-58.45491653427058, -34.53521370404917],
    [-58.45496838018653, -34.53526383765592],
    [-58.4550461994225, -34.53529242170788],
    [-58.45508367237352, -34.5352924226072],
    [-58.45677707420259, -34.53616400866201],
    [-58.45689002815226, -34.53622090696922],
    [-58.458789977275615, -34.53709565414107],
    [-58.4586575143328, -34.5371627336732],
    [-58.45847589084963, -34.53726975569464],
    [-58.456263039707494, -34.536331614412404],
    [-58.455745089564175, -34.5360288243707],
    [-58.45497400544593, -34.5356607471457],
    [-58.45413526982679, -34.535190240736995],
    [-58.4538763010504, -34.535045788032676],
    [-58.45374124356351, -34.53498988167763],
    [-58.4536845449058, -34.534949126201184],
    [-58.453639977203125, -34.53492234618926],
    [-58.453617783733705, -34.534885556723],
    [-58.45364402595101, -34.53486373827087],
    [-58.45362183517949, -34.53482523739473],
    [-58.453613660342114, -34.53479674417434],
    [-58.453644036742844, -34.53476500709934],
    [-58.45366228218853, -34.534741563572254],
    [-58.45366228488649, -34.53471135804267],
    [-58.45362994076913, -34.5346494136395],
    [-58.45362662137143, -34.534605413409054],
    [-58.45364676708459, -34.53444798438693],
    [-58.453669868869326, -34.5343788283202],
    [-58.45366124886749, -34.53431679308551],
    [-58.45362090617982, -34.534273872940844],
    [-58.453551716838206, -34.534233387261],
    [-58.453445058142904, -34.53417135112693],
    [-58.45334729374258, -34.534123470321845],
    [-58.45324594014795, -34.53403023490739],
    [-58.45312778721757, -34.533899852096454],
    [-58.45232347764636, -34.5328652000689],
    [-58.452102821787776, -34.53254472126184],
    [-58.452021781180235, -34.532451568584975],
    [-58.451873273432795, -34.53221297125157],
    [-58.45177417263989, -34.532101152246355],
    [-58.451729165168786, -34.532011702078364],
    [-58.45177419692163, -34.53191487027499],
    [-58.45181024714515, -34.53179188798521],
    [-58.45176075115768, -34.53166141164479],
    [-58.45167521214131, -34.53161667936621],
    [-58.45167971234878, -34.53156456275434],
    [-58.45163918619943, -34.53156455825774],
    [-58.45159417063445, -34.53152722290298],
    [-58.451522096267695, -34.531594297039135],
    [-58.451471945573815, -34.53165767676035],
    [-58.45142287856294, -34.531686071954596],
    [-58.451089714818465, -34.532093668088294],
    [-58.450864479611994, -34.53242905405756],
    [-58.4507654309798, -34.53259296179573],
    [-58.45074286159377, -34.53269728135439],
    [-58.450720363254106, -34.532935857104064],
    [-58.45069327207682, -34.53323024388061],
    [-58.45062117972361, -34.53339794316048],
    [-58.45061667232153, -34.533505959832155],
    [-58.450554023749135, -34.533605045336515],
    [-58.45047555969927, -34.533710617650854],
    [-58.45040949909907, -34.53379662701269],
    [-58.45034191504732, -34.533856307822305],
    [-58.450310355138754, -34.533979290112086],
    [-58.4502247495725, -34.53436311356677],
    [-58.4500670903239, -34.53464630288454],
    [-58.45002390218127, -34.535004165609735],
    [-58.450008513881755, -34.53514193725056],
    [-58.450071490706705, -34.53525374996053],
    [-58.45014804099924, -34.53533950931086],
    [-58.45029665756465, -34.53545502992563],
    [-58.45047672971725, -34.53554449897939],
    [-58.4505443092724, -34.53552963138736],
    [-58.45071998913613, -34.5355482275686],
    [-58.45093161130478, -34.53558558540641],
    [-58.451039713412, -34.535607959639606],
    [-58.451120768408714, -34.53561915170246],
    [-58.4511973321911, -34.53561916159498],
    [-58.451260326103124, -34.535619169688914],
    [-58.45131891783376, -34.53560421126531],
    [-58.451381912645104, -34.535600523145604],
    [-58.45148552533669, -34.53560053573608],
    [-58.451589048096025, -34.53559306596719],
    [-58.45168367116446, -34.53561922724549],
    [-58.45181423114184, -34.535693720788515],
    [-58.45192800077655, -34.535676603992044],
    [-58.45201238416416, -34.53566399189964],
    [-58.45218348557938, -34.535641653639345],
    [-58.45235017761854, -34.53567521813676],
    [-58.452570793907, -34.53565658418398],
    [-58.45271043973497, -34.53567147875572],
    [-58.45287704274131, -34.53569764902721],
    [-58.452971577676124, -34.53570884198945],
    [-58.45307159487817, -34.535713174023726],
    [-58.45312021042935, -34.53572742198287],
    [-58.45317421561754, -34.53574239119837],
    [-58.4532328019522, -34.535779631224955],
    [-58.45332732879314, -34.53586907779567],
    [-58.45354352401438, -34.53601064277689],
    [-58.453701130202944, -34.536152297690364],
    [-58.453730331189774, -34.53619882411641],
    [-58.45411985724559, -34.536517569929856],
    [-58.45415139107382, -34.53660322855609],
    [-58.454430564918596, -34.536946135555695],
    [-58.45449364156826, -34.53703179508125],
    [-58.45459715803236, -34.53710266795372],
    [-58.45477282530561, -34.53730761895139],
    [-58.45481783817263, -34.53740076173574],
    [-58.45482680891007, -34.537564772895905],
    [-58.454790764082475, -34.53765791298224],
    [-58.45475921496575, -34.53772869322455],
    [-58.45473224699555, -34.5378144399844],
    [-58.454705911248766, -34.53786781834509],
    [-58.45469170465839, -34.53794860624316],
    [-58.45480879189222, -34.538034355700916],
    [-58.454835748171206, -34.53807529194114],
    [-58.45490332322976, -34.53812750028385],
    [-58.454826753152076, -34.53816473581384],
    [-58.45481327681125, -34.53812001432715],
    [-58.45477724457413, -34.53808277519988],
    [-58.45463759964548, -34.538015686674555],
    [-58.45459256519467, -34.538138671662296],
    [-58.45451598972113, -34.53823929500743],
    [-58.45445298321857, -34.538339919251825],
    [-58.4543403683133, -34.53848156607137],
    [-58.454254796921305, -34.538652968759436],
    [-58.45416465337604, -34.53873862378839],
    [-58.45408807880176, -34.53880570511916],
    [-58.4539755610233, -34.53885421095305],
    [-58.45379537016015, -34.538943652127784],
    [-58.45310632219895, -34.53929023015996],
    [-58.45281351912854, -34.53942806835062],
    [-58.45271448218756, -34.539450415604165],
    [-58.45265139204804, -34.53947276915295],
    [-58.45252529270806, -34.53960313127942],
    [-58.45217400582567, -34.539565846286735],
    [-58.451908316415654, -34.539196852652594],
    [-58.451926401781975, -34.53901796580641],
    [-58.45162467473892, -34.53867511636349],
    [-58.451413067858766, -34.538462656926015],
    [-58.45133651127094, -34.53839926011773],
    [-58.451237480625196, -34.53838067292969],
    [-58.451278030156914, -34.53823533079583],
    [-58.45119240210761, -34.53814208818676],
    [-58.45110092216976, -34.53811439626236],
    [-58.45101006995873, -34.5380940958658],
    [-58.4508481371318, -34.53805241768487],
    [-58.45066159255839, -34.53793662007894],
    [-58.450450607109815, -34.53781685196611],
    [-58.450222368167715, -34.537676705215745],
    [-58.44994957591217, -34.537426458064544],
    [-58.44987751503527, -34.53735557799746],
    [-58.44988202873259, -34.5372214117387],
    [-58.44987756629661, -34.53702394939569],
    [-58.44987758788034, -34.536878600966645],
    [-58.44993622637571, -34.53657673542796],
    [-58.449940731979154, -34.536487290655884],
    [-58.450017350620215, -34.53613322037177],
    [-58.449495026174475, -34.53579782361061],
    [-58.44911224323539, -34.53558534258946],
    [-58.44904017876121, -34.53554430832315],
    [-58.44893207305671, -34.535555474305625],
    [-58.44890061567082, -34.53558152766533],
    [-58.448819548982954, -34.5356412066763],
    [-58.44877901114239, -34.535704498263954],
    [-58.44880138087899, -34.53573371363996],
    [-58.4487924775907, -34.535779067350006],
    [-58.44879696161047, -34.53583127299481],
    [-58.44930131940032, -34.53612194377263],
    [-58.44937786609563, -34.53622257880892],
    [-58.44939133164462, -34.53631202627895],
    [-58.44935528142105, -34.536408948913845],
    [-58.44887333113928, -34.537008847080585],
    [-58.44876070993877, -34.53713181857853],
    [-58.448711719370294, -34.53722017517089],
    [-58.44872069910093, -34.53726129217483],
    [-58.44878322896278, -34.53735173609368],
    [-58.44884621208297, -34.53743370480157],
    [-58.44890029011623, -34.537553000770345],
    [-58.44899930007762, -34.53768339437312],
    [-58.449084840892624, -34.537754276238786],
    [-58.449179451370526, -34.537866094344736],
    [-58.449215480010366, -34.53790703418224],
    [-58.44917494756572, -34.537929390428985],
    [-58.449092190152385, -34.53787428716856],
    [-58.44903981273711, -34.53778781105859],
    [-58.44888221644112, -34.537623779214016],
    [-58.44883270426584, -34.53760141217538],
    [-58.448774129622336, -34.53748959766676],
    [-58.44870665528788, -34.53741132517246],
    [-58.44859406736225, -34.53733683432739],
    [-58.44846796172703, -34.53747467971266],
    [-58.448022097641626, -34.53772059213156],
    [-58.44671478016295, -34.53843579417651],
    [-58.44655624137738, -34.53851448665421],
    [-58.449253926927156, -34.542598020282355],
    [-58.45018096517936, -34.54381820694465],
    [-58.453797746169016, -34.54848575761156],
    [-58.454197495717835, -34.54909870673987],
    [-58.4542146278028, -34.549372820998826],
    [-58.453243807855415, -34.550263691216344],
    [-58.4530781968013, -34.55049782971105],
    [-58.453106751175596, -34.55050734813557],
    [-58.45642657512627, -34.55224340301061],
    [-58.4611108127138, -34.55476239596777],
    [-58.46346362444666, -34.55589311537494],
    [-58.46648553987575, -34.55748973396402],
    [-58.46919336618089, -34.55890789288492],
    [-58.47006900817814, -34.55797990314994],
    [-58.47087326558869, -34.55706619015251],
    [-58.471553791574195, -34.55616675299319],
    [-58.47251985320861, -34.55494846929639],
    [-58.47364771726831, -34.553506516112805],
    [-58.47445197467886, -34.552411963840996],
    [-58.46822667142368, -34.54893826768688],
    [-58.475880413750076, -34.538598379911264],
    [-58.46589403058499, -34.53418781411631],
    [-58.464986237824576, -34.53378682260376],
    [-58.46379566134067, -34.533260765072214],
    [-58.4611963643207, -34.53027511660332],
    [-58.46113279124529, -34.530202092552486],
    [-58.46089898729838, -34.52993348394307],
    [-58.45894873999231, -34.52769326643107],
    [-58.45889312321901, -34.5276198700609],
    [-58.45889259801493, -34.527619888946674],
    [-58.4588023708327, -34.527623292880605],
    [-58.458699127762486, -34.527616438248],
    [-58.458633173282294, -34.52764032963745],
    [-58.45851591158004, -34.527680451091896],
    [-58.458443306613276, -34.52772228575486],
    [-58.458364952280704, -34.52774284155885],
    [-58.458298909666894, -34.527739414242546],
    [-58.45820815907922, -34.52769162426898],
    [-58.45810914192333, -34.527643742564635],
    [-58.45804310020884, -34.52760623184207],
    [-58.45796052625724, -34.52757548402133],
    [-58.457845063199045, -34.527572054906386],
    [-58.45775008759642, -34.52756177295743],
    [-58.45766346939354, -34.52755834384243],
    [-58.45749840422792, -34.52757547233011],
    [-58.457400102033034, -34.527600084975916],
    [-58.457340887971554, -34.52759341110698],
    [-58.457234230175516, -34.52760531003696],
    [-58.4571310788362, -34.527576002930175],
    [-58.45704365124345, -34.52757924588542],
    [-58.45687688276189, -34.527555259167855],
    [-58.45678181722707, -34.527540918578495],
    [-58.456655031704315, -34.5275528184078]
  ]
];

export { ZPARCoordinates };
